import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Alert,
  IconButton,
  Tooltip,
  Paper,
  Chip,
  Tabs,
  Tab,
  Stack,
  SvgIcon,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Checkbox,
  FormControlLabel,
  ListItemText,

} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme, styled, alpha } from "@mui/material/styles";
import { useEffect, useState, useMemo, useCallback } from "react";
import AlerteService from "../../api/services/AlerteService";
import SocieteService from "../../api/services/SocieteService";
import Header from "../../components/Header";
import EditIcon from "@mui/icons-material/Edit";
import MarqueService from "../../api/services/MarqueService";
import { Download } from "@mui/icons-material";
import OutlinedInput from "@mui/material/OutlinedInput";
import BrevetService from "../../api/services/BrevetService";
import ContratService from "../../api/services/ContratService";
import NomDomaineService from "../../api/services/NomDomaineService";
import jsPDF from "jspdf";

import {
  Delete,
  Search,
  Copyright,
  AccountBalance,
  AccountBalanceWallet,
  Language,
} from "@mui/icons-material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CloseIcon from "@mui/icons-material/Close";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { ResiliationModal, RenouvellementModal } from "./../../components/AlerteDetailsModal";

// ─── Styled components ───────────────────────────────────────────────────────

const StyledCard = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(135deg, ${alpha("#2a5fa9", 0.05)} 0%, ${alpha("#65b986", 0.05)} 100%)`,
  backdropFilter: "blur(10px)",
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  borderRadius: "16px",
  padding: "24px",
}));

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: "none",
  borderRadius: "12px",
  background: alpha(theme.palette.background.paper, 0.95),
  boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.08)}`,
  "& .MuiDataGrid-columnHeaders": {
    background:
      "linear-gradient(90deg, #2a5fa9 0%, #3a7fb5 20%, #4a9fc0 40%, #5ab8a0 60%, #70bd8d 80%, #8fc68b 100%)",
    color: "#ffffff",
    fontWeight: 600,
    fontSize: "0.85rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  "& .MuiDataGrid-cell": { padding: "10px 12px" },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(135deg, #2a5fa9 0%, #65b986 100%)`,
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: 700,
  fontSize: "1.5rem",
  marginBottom: "24px",
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

const ActionIconButton = styled(IconButton)(({ theme, colorhex }) => ({
  background: alpha(colorhex || "#2a5fa9", 0.1),
  color: colorhex || "#2a5fa9",
  width: 32,
  height: 32,
  "&:hover": {
    background: alpha(colorhex || "#2a5fa9", 0.22),
    transform: "scale(1.1)",
  },
  transition: "all 0.2s ease",
}));

const GradientIcon = ({ IconComponent, ...props }) => (
  <SvgIcon {...props} sx={{ fontSize: "1.5rem" }}>
    <defs>
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#2a5fa9" />
        <stop offset="20%" stopColor="#3a7fb5" />
      </linearGradient>
    </defs>
    <IconComponent sx={{ fill: "url(#gradient)" }} />
  </SvgIcon>
);

// ─── Composant principal ─────────────────────────────────────────────────────

const AdminAlertes = () => {
  const theme = useTheme();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("user_role") || "admin";

  const [alertes, setAlertes] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [societes, setSocietes] = useState([]);
  const [societeFilter, setSocieteFilter] = useState("");
  const [loadingSocietes, setLoadingSocietes] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
  const [selectedAlerte, setSelectedAlerte] = useState(null);

  const [resiliationModal, setResiliationModal] = useState({ open: false, item: null, type: null });
  const [renouvellementModal, setRenouvellementModal] = useState({ open: false, item: null, type: null });

  const [selectedEdit, setSelectedEdit] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedMarque, setSelectedMarque] = useState(null);
  const [submitAttemptedEdit, setSubmitAttemptedEdit] = useState(false);
  const [marques, setMarques] = useState([]);
  const [customProprietaireEdit, setCustomProprietaireEdit] = useState(false);
  const [customMandataireEdit, setCustomMandataireEdit] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [firstErrorField, setFirstErrorField] = useState("");
  const [isClassesSelectOpen, setIsClassesSelectOpen] = useState(false);
  const [classes, setClasses] = useState([]);

  // États pour les contrats
  const [selectedContrat, setSelectedContrat] = useState(null);
  const [editFichierPdf, setEditFichierPdf] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [allSocietes, setAllSocietes] = useState([]);
  const [periodicitesPaiement] = useState(["Mensuel", "Trimestriel", "Semestriel", "Annuel"]);
  const [tauxTVAOptions] = useState(["20", "19", "10", "5.5", "0"]);
  const [contratFormErrors, setContratFormErrors] = useState({});
  const [contratEtats] = useState(["A renouveler", "Ne pas renouveler", "Résilié", "Préavis en cours", "En-cours", "a étudier"]);
  const [statut, setStatut] = useState("");

  // États pour les domaines
  const [selectedDomaine, setSelectedDomaine] = useState(null);
  const [proprietaires, setProprietaires] = useState([]);
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [hebergeurs, setHebergeurs] = useState([]);
  const [numerosInternes, setNumerosInternes] = useState([]);
  const [customUtilisateurEdit, setCustomUtilisateurEdit] = useState(false);
  const [domaineFormErrors, setDomaineFormErrors] = useState({});
  const [marqueSearch, setMarqueSearch] = useState("");
  const [numeroInterneSearch, setNumeroInterneSearch] = useState("");
  // Fonctions pour les contrats
  const calculateFinContrat = (dateSignature, duree) => {
    if (!dateSignature || !duree) return "";
    const date = new Date(dateSignature);
    if (isNaN(date.getTime())) return "";
    date.setMonth(date.getMonth() + Number(duree));
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  // Récupérer toutes les sociétés
  // Récupérer toutes les sociétés
  const fetchAllSocietes = async () => {
    if (!token) return;
    try {
      const data = await SocieteService.getAll(token, role);  // Passez role au lieu de userRole
      setAllSocietes(data);
    } catch (err) {
      console.error("Erreur sociétés:", err);
    }
  };

  // Récupérer les données pour les domaines
  const fetchDomainesData = useCallback(async () => {
    if (!token) return;
    try {
      const response = await NomDomaineService.getAllNomsDomaine(role);
      const noms = Array.isArray(response.nomsDomaine) ? response.nomsDomaine : [];
      const marquesList = Array.isArray(response.marques) ? response.marques : [];

      setMarques(marquesList.map((m, idx) => ({
        id: m.id ?? idx + 1,
        nom: m.nom,
        numero_marque: m.numero_marque || "",
        zone_de_protection: m.zone_de_protection || "",
      })));

      const mapUnique = (array, key, nameField = "nom") => {
        const unique = [...new Set(array.map(item => item[key]).filter(Boolean))];
        return unique.map((value, idx) => ({ id: idx + 1, [nameField]: value }));
      };

      setNumerosInternes(mapUnique(noms, "numero_interne", "numero"));
      setProprietaires(mapUnique(noms, "proprietaire"));
      setUtilisateurs(mapUnique(noms, "utilisateur"));
      setHebergeurs(mapUnique(noms, "hebergeur"));
    } catch (err) {
      console.error("Erreur chargement données domaines:", err);
    }
  }, [token, role]);

  const calculateDatePreavis = (finContrat, delaiPreavis) => {
    if (!finContrat || !delaiPreavis) return "";
    const date = new Date(finContrat);
    if (isNaN(date.getTime())) return "";
    date.setMonth(date.getMonth() - Number(delaiPreavis));
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  // Fonction validateContrat corrigée
  const validateContrat = (data) => {
    const errors = {};
    if (!data?.n_contact?.toString().trim()) errors.n_contact = "Le numéro de contact est requis.";
    if (!data?.compte_comptable?.toString().trim()) errors.compte_comptable = "Le compte comptable est requis.";
    if (!data?.societe_id && role === "admin") errors.societe_id = "La société est requise.";  // Utilisez role au lieu de userRole
    if (!data?.nom_fournisseur?.toString().trim()) errors.nom_fournisseur = "Le nom du fournisseur est requis.";
    if (!data?.adresse_fournisseur?.toString().trim()) errors.adresse_fournisseur = "L'adresse du fournisseur est requise.";
    if (!data?.duree?.toString().trim()) errors.duree = "La durée est requise.";
    if (!data?.etat?.toString().trim()) errors.etat = "L'état du contrat est requis.";
    return errors;
  };

  // Fonctions pour les domaines
  const validateDomaine = (data) => {
    const errors = {};
    if (!data?.societe_id) errors.societe_id = "La société est requise.";
    if (!data?.nom_domaine?.trim()) errors.nom_domaine = "Le nom de domaine est requis.";
    if (!data?.compte_comptable?.trim()) errors.compte_comptable = "Le compte comptable est requis.";
    if (data?.automatique && !data?.periodicite) errors.periodicite = "La périodicité est requise pour le renouvellement automatique.";
    return errors;
  };

  const calculateRenewalDate = (periodicite) => {
    if (!periodicite) return "";
    const years = parseInt(periodicite.match(/\d+/)[0], 10);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const renewalDate = new Date(today);
    renewalDate.setFullYear(today.getFullYear() + years);
    return renewalDate.toISOString().split("T")[0];
  };

  const calculatePeriodicity = (renewalDate) => {
    if (!renewalDate) return "";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const renewal = new Date(renewalDate);
    const years = renewal.getFullYear() - today.getFullYear();
    if (years < 1 || years > 10) return "";
    return `${years} an(s)`;
  };
  const protectionZones = [
    { id: 1, name: "France" },
    { id: 2, name: "UE" },
    { id: 3, name: "UK" },
    { id: 4, name: "USA" },
    { id: 5, name: "Canada" },
    { id: 6, name: "Suisse" },
  ];

  const etatsDisponibles = [
    "A déposer", "Déposer", "Cédée", "Non déposée", "En cours", "Opposable",
    "Opposition", "Problème", "Refus", "Expiré", "Enregistrée", "Protégée", "Renouvelé", "Non renouvelé",
  ];

  const uniqueProprietaires = useMemo(() => {
    const proprietaires = marques.map(m => m.proprietaire).filter(p => p && p.trim() !== "").map(p => p.trim());
    return [...new Set(proprietaires)].sort();
  }, [marques]);

  const uniqueCabinetsSurveilleurs = useMemo(() => {
    const cabinets = marques.map(m => m.cabinet_surveilleur).filter(c => c && c.trim() !== "").map(c => c.trim());
    return [...new Set(cabinets)].sort();
  }, [marques]);

  const uniqueMandataires = useMemo(() => {
    const mandataires = marques.map(m => m.mandataire).filter(m => m && m.trim() !== "").map(m => m.trim());
    return [...new Set(mandataires)].sort();
  }, [marques]);

  // Sociétés uniques à partir des marques
  const uniqueSocietes = useMemo(() => {
    const map = new Map();
    marques.forEach(m => {
      if (m.societe?.id && m.societe?.nom) {
        map.set(m.societe.id, { id: m.societe.id, nom: m.societe.nom });
      }
    });
    return Array.from(map.values()).sort((a, b) => a.nom.localeCompare(b.nom));
  }, [marques]);

  const fetchAlertes = useCallback(async () => {
    if (!token) return setError("Aucun jeton d'authentification.");
    setIsLoading(true);
    try {
      const response = await AlerteService.getAlertes(token, role);
      setAlertes(Array.isArray(response) ? response : []);
      setError("");
    } catch (err) {
      setError(err.response?.data?.message || "Erreur de chargement.");
    } finally {
      setIsLoading(false);
    }
  }, [token, role]); // ← dépendances stables

  const fetchMarques = useCallback(async () => {
    if (!token) { setError("Utilisateur non authentifié."); return; }
    try {
      const responseData = await MarqueService.getMarques(role, token);

      const marquesData = Array.isArray(responseData)
        ? responseData
        : responseData.resultats || [];

      setMarques(marquesData);
      if (responseData.societes && responseData.societes.length > 0) {
        setSocietes(responseData.societes);
      } else {
        const societesMap = new Map();
        marquesData.forEach(m => {
          if (m.societe?.id && m.societe?.nom) {
            societesMap.set(m.societe.id, { id: m.societe.id, nom: m.societe.nom });
          }
        });
        setSocietes(Array.from(societesMap.values()).sort((a, b) => a.nom.localeCompare(b.nom)));
      }

      setError("");
    } catch (err) {
      setError(err.message || "Erreur lors de la récupération des marques.");
    }
  }, [token, role]);

  const calculateDerivedDates = (dateDepot, datePublication) => {
    let date_de_protection = "", date_de_renouvellement = "", date_de_fin_opposition = "";
    if (dateDepot && !isNaN(new Date(dateDepot))) {
      const depot = new Date(dateDepot);
      date_de_protection = depot.toISOString().split("T")[0];
      const renouvellement = new Date(depot);
      renouvellement.setFullYear(depot.getFullYear() + 10);
      date_de_renouvellement = renouvellement.toISOString().split("T")[0];
    }
    if (datePublication && !isNaN(new Date(datePublication))) {
      const publication = new Date(datePublication);
      const opposition = new Date(publication);
      opposition.setMonth(publication.getMonth() + 2);
      date_de_fin_opposition = opposition.toISOString().split("T")[0];
    }
    return { date_de_protection, date_de_renouvellement, date_de_fin_opposition };
  };

  useEffect(() => { fetchAlertes(); }, [role, token]);

  useEffect(() => {
    const loadSocietes = async () => {
      if (!token) return;
      setLoadingSocietes(true);
      try {
        const data = await SocieteService.getAll(token, role);
        setSocietes(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Erreur chargement sociétés:", err);
      } finally {
        setLoadingSocietes(false);
      }
    };
    loadSocietes();
  }, [token]);

  const [selectedBrevet, setSelectedBrevet] = useState(null);
  const [inventeurs, setInventeurs] = useState([]);
  const [titulaires, setTitulaires] = useState([]);
  const [debiteurs, setDebiteurs] = useState([]);
  const [ayantsDroit, setAyantsDroit] = useState([]);
  const [newInventeur, setNewInventeur] = useState("");
  const [newTitulaire, setNewTitulaire] = useState("");
  const [newDebiteur, setNewDebiteur] = useState("");
  const [newAyantDroit, setNewAyantDroit] = useState("");
  const [newCountry, setNewCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedCertificatDepotFile, setSelectedCertificatDepotFile] = useState(null);
  const [selectedCertificatEnregistrementFile, setSelectedCertificatEnregistrementFile] = useState(null);
  const [brevetFormErrors, setBrevetFormErrors] = useState({});
  const [editType, setEditType] = useState(null); // 'marque' ou 'brevet'

  // Constantes pour les brevets
  const royaltyTypes = ["% CA HT", "Somme sur les ventes"];
  const royaltyFrequencies = ["Trimestrielle", "Semestrielle", "Annuelle"];
  const etatsBrevets = ['Déchu', 'Actif', 'Déposé', 'A déposer', 'Publié', 'Opposable', 'Litige'];

  // MenuProps pour les selects multiples
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 250,
      },
    },
  };

  // Fonction pour valider le brevet
  const validateBrevet = (data) => {
    const errors = {};

    if (!data?.Code_Famille_CEGID?.trim()) {
      errors.Code_Famille_CEGID = "Le code famille est requis.";
    }
    if (!data?.societe_id || data.societe_id === "" || data.societe_id == null) {
      errors.societe_id = "La société est requise.";
    }
    if (!data?.nom?.trim()) {
      errors.nom = "Le nom est requis.";
    }
    if (!data?.compte_comptable?.trim()) {
      errors.compte_comptable = "Le compte comptable est requis.";
    }
    if (!data?.pays || data.pays.length === 0) {
      errors.pays = "Au moins un pays doit être sélectionné.";
    }
    if (!data?.date_depot?.trim()) {
      errors.date_depot = "La date de dépôt est requise.";
    }

    return errors;
  };

  // Fonction pour récupérer les brevets
  const fetchBrevets = useCallback(async () => {
    if (!token) return;
    try {
      const responseData = await BrevetService.getBrevet(role, token);
      const brevetsData = responseData.brevets || [];

      // Extraire les listes uniques pour les parties prenantes
      const uniqueInventeurs = [...new Set(brevetsData.map(b => b.inventeur).filter(Boolean))].sort();
      setInventeurs(uniqueInventeurs);
      const uniqueTitulaires = [...new Set(brevetsData.map(b => b.titulaire).filter(Boolean))].sort();
      setTitulaires(uniqueTitulaires);
      const uniqueDebiteurs = [...new Set(brevetsData.map(b => b.debiteur_annuites).filter(Boolean))].sort();
      setDebiteurs(uniqueDebiteurs);
      const uniqueAyants = [...new Set(brevetsData.map(b => b.ayant_droit).filter(Boolean))].sort();
      setAyantsDroit(uniqueAyants);
      setCountries(responseData.countries || []);
    } catch (err) {
      console.error("Erreur chargement brevets:", err);
    }
  }, [token, role]);

  const handleEditClick = async (row) => {
    if (row.type === "marque") {
      setEditType("marque");
      try {
        setIsLoading(true);
        const marque = await MarqueService.getMarqueById(role, token, row.rawId);

        const formatDate = (dateStr) => {
          if (!dateStr) return "";
          return dateStr.split("T")[0];
        };

        setSelectedMarque({
          ...marque,
          marque_id: marque.marque_id,
          classes: Array.isArray(marque.classes) ? marque.classes : [],
          zone_de_protection: Array.isArray(marque.zone_de_protection)
            ? marque.zone_de_protection
            : [],
          etat_de_la_marque: marque.etat_de_la_marque || "",
          cout: marque.cout || "",
          devise: marque.devise || "",
          commentaire: marque.commentaire || "",
          noms_domaine_associes: marque.noms_domaine_associes || "",
          date_depot: formatDate(marque.date_depot),
          date_de_publication: formatDate(marque.date_de_publication),
          date_de_fin_opposition: formatDate(marque.date_de_fin_opposition),
          date_de_protection: formatDate(marque.date_de_protection),
          date_de_renouvellement: formatDate(marque.date_de_renouvellement),
          existing_certificat_depot_pdf: marque.certificat_depot_pdf || null,
          existing_certificat_enregistrement_pdf: marque.certificat_enregistrement_pdf || null,
          certificat_depot_pdf: null,
          certificat_enregistrement_pdf: null,
        });

        setOpenEdit(true);
        setSubmitAttemptedEdit(false);
      } catch (err) {
        setError("Impossible de charger les données de la marque.");
      } finally {
        setIsLoading(false);
      }
    }
    else if (row.type === "brevet") {
      setEditType("brevet");
      try {
        setIsLoading(true);
        const brevet = await BrevetService.getBrevetById(role, token, row.rawId);

        const formatDate = (dateStr) => {
          if (!dateStr) return "";
          return dateStr.split("T")[0];
        };

        let paysValue = [];
        if (Array.isArray(brevet.pays)) {
          paysValue = brevet.pays;
        } else if (typeof brevet.pays === "string") {
          const trimmedPays = brevet.pays.trim();
          if (trimmedPays.startsWith('[') && trimmedPays.endsWith(']')) {
            try {
              paysValue = JSON.parse(trimmedPays);
            } catch (parseErr) {
              paysValue = [trimmedPays];
            }
          } else {
            paysValue = [trimmedPays];
          }
        }

        setSelectedBrevet({
          id: brevet.id,
          Code_Famille_CEGID: brevet.Code_Famille_CEGID || "",
          societe_id: brevet.societe_id || "",
          nom: brevet.nom || "",
          compte_comptable: brevet.compte_comptable || "",
          descriptif: brevet.descriptif || "",
          numero_brevet: brevet.numero_brevet || "",
          numero_dossier: brevet.numero_dossier || "",
          mandataire: brevet.mandataire || "",
          inventeur: brevet.inventeur || "",
          titulaire: brevet.titulaire || "",
          debiteur_annuites: brevet.debiteur_annuites || "",
          ayant_droit: brevet.ayant_droit || "",
          pays: paysValue,
          type_royalties: brevet.type_royalties || "",
          montant_royalties: brevet.montant_royalties || "",
          frequence_royalties: brevet.frequence_royalties || "",
          date_depot: formatDate(brevet.date_depot),
          date_publication: formatDate(brevet.date_publication),
          date_echeance_annuites: formatDate(brevet.date_echeance_annuites),
          date_expiration: formatDate(brevet.date_expiration),
          etat: brevet.etat || "",
          commentaires: brevet.commentaires || "",
          certificat_depot_pdf: brevet.certificat_depot_pdf || null,
          certificat_enregistrement_pdf: brevet.certificat_enregistrement_pdf || null,
        });

        setNewCountry("");
        setNewInventeur("");
        setNewTitulaire("");
        setNewDebiteur("");
        setNewAyantDroit("");
        setSelectedCertificatDepotFile(null);
        setSelectedCertificatEnregistrementFile(null);
        setBrevetFormErrors({});
        setOpenEdit(true);
      } catch (err) {
        setError("Impossible de charger les données du brevet.");
      } finally {
        setIsLoading(false);
      }
    }

    else if (row.type === "contrat") {
      setEditType("contrat");
      try {
        setIsLoading(true);
        const contrat = await ContratService.getContratById(role, token, row.rawId);

        const finContrat = contrat.fin_contrat
          ? new Date(contrat.fin_contrat).toISOString().split("T")[0]
          : calculateFinContrat(contrat.date_signature, contrat.duree);

        const datePreavis = contrat.date_preavis
          ? new Date(contrat.date_preavis).toISOString().split("T")[0]
          : calculateDatePreavis(finContrat, contrat.delai_preavis);

        setSelectedContrat({
          ...contrat,
          id: contrat.id,
          societe_id: contrat.societe_id || "",
          date_signature: contrat.date_signature ? new Date(contrat.date_signature).toISOString().split("T")[0] : "",
          fin_contrat: finContrat || "",
          date_preavis: datePreavis || "",
          reconduction_tacite: contrat.reconduction_tacite?.toLowerCase() === "oui" ? "oui" : "non",
          periode_reengagement: contrat.periode_reengagement || "12",
        });

        setEditFichierPdf(null);
        setContratFormErrors({});
        setOpenEdit(true);
      } catch (err) {
        setError("Impossible de charger les données du contrat.");
      } finally {
        setIsLoading(false);
      }
    }
    else if (row.type === "domaine") {
      setEditType("domaine");
      try {
        setIsLoading(true);

        let cleanId = row.rawId;
        if (typeof cleanId === 'string' && cleanId.includes('|')) {
          cleanId = cleanId.split('|')[0];
        }
        cleanId = cleanId.toString().replace(/[^0-9]/g, '');

        console.log("Fetching domaine with ID:", cleanId);

        const response = await NomDomaineService.getNomDomaineById(role, cleanId);
        console.log("Response received:", response); // Debug

        const domaine = response;

        const dateRenouvellement = domaine.date_renouvellement
          ? new Date(domaine.date_renouvellement).toISOString().split("T")[0]
          : "";

        let periodiciteFormatted = domaine.periodicite || "";
        if (periodiciteFormatted && !periodiciteFormatted.includes("an")) {
          periodiciteFormatted = `${periodiciteFormatted} an(s)`;
        }

        setSelectedDomaine({
          id: domaine.id,
          numero_interne: domaine.numero_interne || "",
          nom_domaine: domaine.nom_domaine || "",
          proprietaire: domaine.proprietaire || "",
          utilisateur: domaine.utilisateur || "",
          marque: domaine.marque || "",
          statut: domaine.statut || "ACTIF",
          date_renouvellement: dateRenouvellement,
          hebergeur: domaine.hebergeur || "",
          renouvellement_ht: domaine.renouvellement_ht || "",
          automatique: domaine.automatique || false,
          periodicite: periodiciteFormatted,
          commentaires: domaine.commentaires || "",
          compte_comptable: domaine.compte_comptable || "",
          societe_id: domaine.societe_id || "",
        });

        console.log("SelectedDomaine set:", selectedDomaine);

        setDomaineFormErrors({});
        setCustomProprietaireEdit(false);
        setCustomUtilisateurEdit(false);
        setOpenEdit(true);
      } catch (err) {
        console.error("Error loading domaine:", err);
        setError("Impossible de charger les données du domaine.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Fonction pour gérer la date de dépôt des brevets
  const handleEditDateDepotChange = (e) => {
    const depot = e.target.value;
    if (!depot) {
      setSelectedBrevet(prev => ({
        ...prev,
        date_depot: '',
        date_publication: '',
        date_expiration: '',
        date_echeance_annuites: ''
      }));
      return;
    }

    const echeance = depot;
    const dateDepot = new Date(depot);
    const publication = new Date(dateDepot);
    publication.setMonth(publication.getMonth() + 18);
    const pubStr = publication.toISOString().split('T')[0];

    const [year, month, day] = depot.split('-').map(Number);
    const expYear = year + 20;
    const expDateStr = `${expYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    const expDate = new Date(expDateStr + 'T00:00:00');
    let expStr = expDateStr;

    if (isNaN(expDate.getTime()) || expDate.getDate() !== day) {
      const lastDayOfMonth = new Date(expYear, month, 0);
      expStr = `${expYear}-${String(month).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;
    }

    setSelectedBrevet(prev => ({
      ...prev,
      date_depot: depot,
      date_publication: pubStr,
      date_expiration: expStr,
      date_echeance_annuites: echeance
    }));
  };

  const handleEditSubmit = async () => {
    if (!token) return;

    try {
      if (editType === "marque") {
        setSubmitAttemptedEdit(true);
        setError("");
        setSnackbarMessage("");
        setFirstErrorField("");

        const validClasses = (selectedMarque?.classes || []).filter(
          id => id !== undefined && id !== null && id !== '' && Number.isInteger(id)
        );

        if (!selectedMarque?.numero?.trim()) {
          setSnackbarMessage("Le champ numéro est requis.");
          setSnackbarSeverity("error");
          setFirstErrorField("numero");
          setSnackbarOpen(true);
          return;
        }

        if (!selectedMarque?.compte_comptable?.trim()) {
          setSnackbarMessage("Le champ Compte Comptable est requis.");
          setSnackbarSeverity("error");
          setFirstErrorField("compte_comptable");
          setSnackbarOpen(true);
          return;
        }

        if (!validClasses.length) {
          setSnackbarMessage("Veuillez sélectionner au moins une classe.");
          setSnackbarSeverity("error");
          setFirstErrorField("classes");
          setSnackbarOpen(true);
          return;
        }

        if (!selectedMarque?.zone_de_protection?.length) {
          setSnackbarMessage("Veuillez sélectionner au moins une zone de protection.");
          setSnackbarSeverity("error");
          setFirstErrorField("zone_de_protection");
          setSnackbarOpen(true);
          return;
        }

        if (!selectedMarque?.societe_id) {
          setSnackbarMessage("Veuillez sélectionner une société.");
          setSnackbarSeverity("error");
          setFirstErrorField("societe_id");
          setSnackbarOpen(true);
          return;
        }

        const { date_de_protection, date_de_renouvellement, date_de_fin_opposition } = calculateDerivedDates(
          selectedMarque.date_depot,
          selectedMarque.date_de_publication
        );

        const marqueToUpdate = {
          ...selectedMarque,
          classes: validClasses,
          date_de_protection: date_de_protection || selectedMarque.date_de_protection,
          date_de_renouvellement: date_de_renouvellement || selectedMarque.date_de_renouvellement,
          date_de_fin_opposition: date_de_fin_opposition || selectedMarque.date_de_fin_opposition,
          societe_id: selectedMarque.societe_id,
        };

        // 1. Mise à jour normale via MarqueService
        await MarqueService.updateMarque(role, token, selectedMarque.marque_id, marqueToUpdate);

        // 2. Suppression de la relation dans l'alerte
        const payload = {
          type: "marque",
          id: selectedMarque.marque_id,
          alerte_id: selectedMarque.alerte_id || selectedMarque.alerte?.id || null,
        };
        await AlerteService.updateFromAlerte(token, role, payload);

      }
      else if (editType === "brevet") {
        const errors = validateBrevet(selectedBrevet);
        setBrevetFormErrors(errors);

        if (Object.keys(errors).length > 0) {
          const firstErrorKey = Object.keys(errors)[0];
          setSnackbarMessage(errors[firstErrorKey]);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          return;
        }

        const formData = new FormData();
        const paysArray = Array.isArray(selectedBrevet.pays) ? selectedBrevet.pays : [];
        paysArray.forEach((pays, index) => formData.append(`pays[${index}]`, pays));

        Object.entries(selectedBrevet).forEach(([key, value]) => {
          if (key === "pays" || key === "id" || key === "certificat_depot_pdf" || key === "certificat_enregistrement_pdf") return;
          if (value !== undefined && value !== null && value !== "") {
            formData.append(key, value);
          }
        });

        if (selectedCertificatDepotFile instanceof File) {
          formData.append("certificat_depot_pdf", selectedCertificatDepotFile);
        }
        if (selectedCertificatEnregistrementFile instanceof File) {
          formData.append("certificat_enregistrement_pdf", selectedCertificatEnregistrementFile);
        }

        formData.append("_method", "PUT");

        // 1. Mise à jour normale via BrevetService
        await BrevetService.updateBrevet(role, token, selectedBrevet.id, formData);

        // 2. Suppression de la relation dans l'alerte
        const payload = {
          type: "brevet",
          id: selectedBrevet.id,
          alerte_id: selectedBrevet.alerte_id || selectedBrevet.alerte?.id || null,
        };
        await AlerteService.updateFromAlerte(token, role, payload);

      }
      else if (editType === "contrat") {
        const errors = validateContrat(selectedContrat);
        setContratFormErrors(errors);

        if (Object.keys(errors).length > 0) {
          const firstErrorKey = Object.keys(errors)[0];
          setSnackbarMessage(errors[firstErrorKey]);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          return;
        }

        const formData = new FormData();

        const fieldsToSend = {
          n_contact: selectedContrat.n_contact || "",
          nom_fournisseur: selectedContrat.nom_fournisseur || "",
          code_fournisseur: selectedContrat.code_fournisseur || "",
          nom_contact: selectedContrat.nom_contact || "",
          telephone_contact: selectedContrat.telephone_contact || "",
          email_contact: selectedContrat.email_contact || "",
          adresse_fournisseur: selectedContrat.adresse_fournisseur || "",
          cp_fournisseur: selectedContrat.cp_fournisseur || "",
          ville_fournisseur: selectedContrat.ville_fournisseur || "",
          pays_fournisseur: selectedContrat.pays_fournisseur || "",
          compte_comptable: selectedContrat.compte_comptable || "",
          etat: selectedContrat.etat || "",
          date_signature: selectedContrat.date_signature || "",
          duree: selectedContrat.duree ? Number(selectedContrat.duree) : "",
          fin_contrat: selectedContrat.fin_contrat || "",
          delai_preavis: selectedContrat.delai_preavis ? Number(selectedContrat.delai_preavis) : "",
          date_preavis: selectedContrat.date_preavis || "",
          periodicite_paiement: selectedContrat.periodicite_paiement || "",
          periode_reengagement: selectedContrat.periode_reengagement ? Number(selectedContrat.periode_reengagement) : 12,
          loyer_ht: selectedContrat.loyer_ht ? Number(selectedContrat.loyer_ht) : 0,
          devise: selectedContrat.devise || "",
          taux_tva_loyer: selectedContrat.taux_tva_loyer ? Number(selectedContrat.taux_tva_loyer) : 0,
          details: selectedContrat.details || "",
          reconduction_tacite: selectedContrat.reconduction_tacite || "non",
          societe_id: selectedContrat.societe_id || "",
          _method: "PUT",
        };

        Object.entries(fieldsToSend).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            formData.append(key, value);
          }
        });

        if (editFichierPdf instanceof File) {
          formData.append("fichier_pdf", editFichierPdf);
        }

        setIsUploading(true);
        setUploadProgress(0);

        // 1. Mise à jour normale via ContratService
        await ContratService.updateContrat(role, token, selectedContrat.id, formData, (percent) => {
          setUploadProgress(percent);
        });

        setIsUploading(false);

        // 2. Suppression de la relation dans l'alerte
        const payload = {
          type: "contrat",
          id: selectedContrat.id,
          alerte_id: selectedContrat.alerte_id || selectedContrat.alerte?.id || null,
        };
        await AlerteService.updateFromAlerte(token, role, payload);

      }
      else if (editType === "domaine") {
        const errors = validateDomaine(selectedDomaine);
        setDomaineFormErrors(errors);

        if (Object.keys(errors).length > 0) {
          const firstErrorKey = Object.keys(errors)[0];
          setSnackbarMessage(errors[firstErrorKey]);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          return;
        }

        // 1. Mise à jour normale via NomDomaineService
        await NomDomaineService.updateNomDomaine(role, selectedDomaine.id, selectedDomaine);

        // 2. Suppression de la relation dans l'alerte
        const payload = {
          type: "domaine",
          id: selectedDomaine.id,
          alerte_id: selectedDomaine.alerte_id || selectedDomaine.alerte?.id || null,
        };
        await AlerteService.updateFromAlerte(token, role, payload);
      }

      // Succès commun
      setOpenEdit(false);
      setSubmitAttemptedEdit(false);
      setSnackbarMessage(`${editType.charAt(0).toUpperCase() + editType.slice(1)} modifié avec succès et retiré des alertes !`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      await fetchAlertes();

    } catch (err) {
      console.error(err);
      setIsUploading(false);
      const errorMessage = err.response?.data?.message || "Erreur lors de la modification.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };




  useEffect(() => {
    fetchBrevets();
  }, [fetchBrevets]);

  useEffect(() => {
    fetchAllSocietes();
    fetchDomainesData();
  }, []);
  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSubmitAttemptedEdit(false);
    setCustomProprietaireEdit(false);
    setCustomMandataireEdit(false);
    // Nettoyage brevets
    setSelectedBrevet(null);
    setBrevetFormErrors({});
    setSelectedCertificatDepotFile(null);
    setSelectedCertificatEnregistrementFile(null);
    setNewCountry("");
    setNewInventeur("");
    setNewTitulaire("");
    setNewDebiteur("");
    setNewAyantDroit("");
    // Nettoyage contrats
    setSelectedContrat(null);
    setEditFichierPdf(null);
    setContratFormErrors({});
    setUploadProgress(0);
    setIsUploading(false);
    // Nettoyage domaines
    setSelectedDomaine(null);
    setDomaineFormErrors({});
    setCustomProprietaireEdit(false);
    setCustomUtilisateurEdit(false);
  };


  const handleDeleteClick = (row) => {
    setSelectedAlerte(row);
    setOpenDelete(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedAlerte?.alerte?.id || !selectedAlerte?.rawId) return;


    const updatedAlertes = alertes.map(alerte => {
      if (alerte.id === selectedAlerte.alerte.id) {
        const updatedAlerte = { ...alerte };

        switch (selectedAlerte.type) {
          case "marque":
            updatedAlerte.marques = alerte.marques.filter(m => m.id !== selectedAlerte.rawId);
            break;
          case "brevet":
            updatedAlerte.brevets = alerte.brevets.filter(b => b.id !== selectedAlerte.rawId);
            break;
          case "contrat":
            updatedAlerte.contrats = alerte.contrats.filter(c => c.id !== selectedAlerte.rawId);
            break;
          case "domaine":
            updatedAlerte.nomsDomaine = alerte.nomsDomaine.filter(nd => nd.id !== selectedAlerte.rawId);
            break;
        }

        return updatedAlerte;
      }
      return alerte;
    });

    const finalAlertes = updatedAlertes.filter(alerte => {
      const hasMarques = alerte.marques?.length > 0;
      const hasBrevets = alerte.brevets?.length > 0;
      const hasContrats = alerte.contrats?.length > 0;
      const hasDomaines = alerte.nomsDomaine?.length > 0;
      return hasMarques || hasBrevets || hasContrats || hasDomaines;
    });

    setAlertes(finalAlertes);
    setOpenDelete(false);
    setSuccess("Élément retiré de l'affichage avec succès !");
    setTimeout(() => setSuccess(""), 3000);
  };


  const buildItemFromRow = (row) => {
    const base = { id: row.rawId };
    switch (row.type) {
      case "marque":
        return {
          ...base,
          nom: row.label,
          date_de_renouvellement: row.date_de_renouvellement,
          etat_de_la_marque: row.etat_de_la_marque,
        };
      case "brevet":
        return {
          ...base,
          nom: row.label,
          numero_brevet: row.numero,
          date_expiration: row.date_expiration,
          etat: row.etat,
        };
      case "contrat":
        return {
          ...base,
          nom_fournisseur: row.label,
          societe_nom: row.alerte?.societe_nom || societes.find(s => s.id === row.societe_id)?.nom || "",
          n_contact: row.numero,
          fin_contrat: row.fin_contrat,
          date_signature: row.date_signature,
          periode_reengagement: row.periode_reengagement,
          delai_preavis: row.delai_preavis,
          etat: row.etat,
        };
      case "domaine":
        return {
          ...base,
          nom_domaine: row.label,
          date_renouvellement: row.date_renouvellement,
          statut: row.statut,
          periodicite: row.periodicite,
        };
      default:
        return base;
    }
  };

  const handleResiliationClick = (row) =>
    setResiliationModal({ open: true, item: buildItemFromRow(row), type: row.type });

  const handleRenouvellementClick = (row) =>
    setRenouvellementModal({ open: true, item: buildItemFromRow(row), type: row.type });

  const handleDownloadPDF = (label, data) => {
    if (!data || data.length === 0) {
      alert("Aucune donnée à exporter.");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 12;
    const availableWidth = pageWidth - 2 * margin;

    // ==================== CONFIGURATION DES COLONNES ====================
    const columns = [
      { header: "Société", key: "societe", width: 48 },
      { header: "Alerte", key: "alerte", width: 42 },
      { header: "Nom", key: "nom", width: 55 },
      { header: "Numéro", key: "numero", width: 35 },
      { header: "Échéance", key: "echeance", width: 38 },
      { header: "Créée le", key: "created", width: 30 },
    ];

    // Calcul des positions X
    let xPositions = [margin];
    columns.forEach((col, i) => {
      if (i > 0) xPositions.push(xPositions[i - 1] + columns[i - 1].width);
    });

    // ==================== TITRE & DATE ====================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(42, 95, 169);
    doc.text(`Alertes — ${label}`, margin, 18);

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(
      `Exporté le ${new Date().toLocaleDateString("fr-FR", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      })}`,
      margin,
      26
    );

    let y = 38;

    // ==================== EN-TÊTE DU TABLEAU ====================
    const headerHeight = 11;
    doc.setFillColor(42, 95, 169);
    doc.rect(margin, y - 5, availableWidth, headerHeight, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(9.5);
    doc.setFont("helvetica", "bold");

    columns.forEach((col, i) => {
      doc.text(col.header, xPositions[i] + 2, y + 1.5);
    });

    y += headerHeight + 3;

    // ==================== LIGNES DE DONNÉES ====================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8.5);
    doc.setTextColor(50, 50, 50);

    const rowPadding = 4;
    const lineHeight = 4.8;

    data.forEach((row, index) => {
      const soc = societes.find((s) => s.id === row.societe_id);
      const rowData = {
        societe: soc ? soc.nom : "-",
        alerte: row.alerte?.nom_alerte || "-",
        nom: row.label || "-",
        numero: row.numero || "-",
        echeance: row.alerte?.quand || "-",
        created: row.created_at
          ? new Date(row.created_at).toLocaleDateString("fr-FR")
          : "-",
      };

      // Calcul de la hauteur nécessaire pour chaque cellule (multi-ligne)
      const cellLines = columns.map((col) => {
        const text = String(rowData[col.key] || "-");
        return doc.splitTextToSize(text, col.width - 4);
      });

      const maxLinesInRow = Math.max(...cellLines.map((lines) => lines.length));
      const rowHeight = maxLinesInRow * lineHeight + rowPadding * 1;

      // Vérification saut de page
      if (y + rowHeight > 200) {
        doc.addPage();
        y = 20;

        // Réafficher l'en-tête sur nouvelle page
        doc.setFillColor(42, 95, 169);
        doc.rect(margin, y - 5, availableWidth, headerHeight, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9.5);

        columns.forEach((col, i) => {
          doc.text(col.header, xPositions[i] + 2, y + 1.5);
        });

        y += headerHeight + 3;
        doc.setTextColor(50, 50, 50);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8.5);
      }

      // // Fond alterné
      // if (index % 2 === 0) {
      //   doc.setFillColor(245, 248, 255);
      //   doc.rect(margin, y - rowPadding, availableWidth, rowHeight, "F");
      // }

      // Dessiner le contenu de chaque cellule
      cellLines.forEach((lines, colIndex) => {
        lines.forEach((line, lineIndex) => {
          doc.text(
            line,
            xPositions[colIndex] + 2,
            y + lineIndex * lineHeight + rowPadding
          );
        });
      });

      // Ligne de séparation
      doc.setDrawColor(220, 220, 220);
      doc.line(
        margin,
        y + rowHeight - 1,
        margin + availableWidth,
        y + rowHeight - 1
      );

      y += rowHeight;
    });

    // Pied de page
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150);
      doc.text(
        `Page ${i} / ${pageCount}`,
        pageWidth - margin - 15,
        doc.internal.pageSize.getHeight() - 8
      );
    }

    // Téléchargement
    const fileName = `alertes_${label.toLowerCase()}_${new Date()
      .toISOString()
      .slice(0, 10)}.pdf`;
    doc.save(fileName);
  };

  const handleActionSuccess = async (entity, _type) => {
    setResiliationModal({ open: false, item: null, type: null });
    setRenouvellementModal({ open: false, item: null, type: null });

    // Mettre à jour l'état local pour cacher l'élément
    if (entity && entity.id) {
      const updatedAlertes = alertes.map(alerte => {
        let updated = false;
        const newAlerte = { ...alerte };

        // Filtrer l'élément traité des listes
        if (newAlerte.marques) {
          const originalLength = newAlerte.marques.length;
          newAlerte.marques = newAlerte.marques.filter(m => m.id !== entity.id);
          if (originalLength !== newAlerte.marques.length) updated = true;
        }
        if (newAlerte.brevets) {
          const originalLength = newAlerte.brevets.length;
          newAlerte.brevets = newAlerte.brevets.filter(b => b.id !== entity.id);
          if (originalLength !== newAlerte.brevets.length) updated = true;
        }
        if (newAlerte.contrats) {
          const originalLength = newAlerte.contrats.length;
          newAlerte.contrats = newAlerte.contrats.filter(c => c.id !== entity.id);
          if (originalLength !== newAlerte.contrats.length) updated = true;
        }
        if (newAlerte.nomsDomaine) {
          const originalLength = newAlerte.nomsDomaine.length;
          newAlerte.nomsDomaine = newAlerte.nomsDomaine.filter(nd => nd.id !== entity.id);
          if (originalLength !== newAlerte.nomsDomaine.length) updated = true;
        }

        return updated ? newAlerte : alerte;
      });

      // Filtrer les alertes vides
      const finalAlertes = updatedAlertes.filter(alerte => {
        return (alerte.marques?.length > 0) ||
          (alerte.brevets?.length > 0) ||
          (alerte.contrats?.length > 0) ||
          (alerte.nomsDomaine?.length > 0);
      });

      setAlertes(finalAlertes);
    }

    setSuccess("Opération effectuée avec succès !");
    setTimeout(() => setSuccess(""), 3000);
  };


  const handleResiliationClose = () => {
    setResiliationModal({ open: false, item: null, type: null });
    fetchAlertes();
  };

  const handleRenouvellementClose = () => {
    setRenouvellementModal({ open: false, item: null, type: null });
    fetchAlertes();
  };


  const dataByType = useMemo(() => {
    const lower = search.toLowerCase();
    const filterBySearch = (arr) =>
      arr.filter((item) =>
        `${item.alerte.nom_alerte} ${item.label}`.toLowerCase().includes(lower)
      );
    const filterBySociete = (arr) =>
      societeFilter ? arr.filter((item) => item.societe_id == societeFilter) : arr;

    const marques = alertes.flatMap((a) =>
      (a.marques || []).map((m) => ({
        id: `${a.id}-marque-${m.id}`, rawId: m.id, alerte: a, type: "marque",
        label: m.nom || "Inconnu", numero: m.numero_marque || "-",
        created_at: m.pivot?.created_at, societe_id: m.societe_id,
        date_de_renouvellement: m.date_de_renouvellement || null,
        etat_de_la_marque: m.etat_de_la_marque || null,
      }))
    );
    const brevets = alertes.flatMap((a) =>
      (a.brevets || []).map((b) => ({
        id: `${a.id}-brevet-${b.id}`, rawId: b.id, alerte: a, type: "brevet",
        label: b.titre || b.nom || "Inconnu", numero: b.numero_brevet || "-",
        created_at: b.pivot?.created_at, societe_id: b.societe_id,
        date_expiration: b.date_expiration || null,
        etat: b.etat || null,
      }))
    );
    const contrats = alertes.flatMap((a) =>
      (a.contrats || []).map((c) => ({
        id: `${a.id}-contrat-${c.id}`, rawId: c.id, alerte: a, type: "contrat",
        label: c.nom_contrat || c.n_contact || c.nom_fournisseur || "Inconnu",
        numero: c.n_contact || "-", created_at: c.pivot?.created_at, societe_id: c.societe_id || null,
        fin_contrat: c.fin_contrat || null,
        date_signature: c.date_signature || null,
        periode_reengagement: c.periode_reengagement || 12,
        delai_preavis: c.delai_preavis || null,
        etat: c.etat || null,
      }))
    );
    const domaines = alertes.flatMap((a) =>
      (a.nomsDomaine || []).map((nd) => ({
        id: `${a.id}-domaine-${nd.id}`, rawId: nd.id, alerte: a, type: "domaine",
        label: nd.nom_domaine || nd.nom || "Inconnu", numero: nd.numero_interne || "-",
        created_at: nd.pivot?.created_at, societe_id: nd.societe_id || null,
        date_renouvellement: nd.date_renouvellement || null,
        statut: nd.statut || null,
        periodicite: nd.periodicite || null,
      }))
    );

    return {
      marques: filterBySociete(filterBySearch(marques)),
      brevets: filterBySociete(filterBySearch(brevets)),
      contrats: filterBySociete(filterBySearch(contrats)),
      domaines: filterBySociete(filterBySearch(domaines)),
    };
  }, [alertes, search, societeFilter]);


  const baseColumns = [
    {
      field: "societe", headerName: "Société", flex: 1, minWidth: 150, sortable: false,
      renderCell: (params) => {
        const soc = societes.find((s) => s.id === params.row.societe_id);
        return soc
          ? <Typography fontWeight="medium" color="primary" noWrap>{soc.nom}</Typography>
          : "-";
      },
    },
    {
      field: "alerte_nom", headerName: "Alerte", flex: 1, minWidth: 150, sortable: false,
      renderCell: (params) => (
        <Typography fontWeight="medium" color="primary" noWrap>
          {params.row.alerte.nom_alerte}
        </Typography>
      ),
    },
    {
      field: "quand", headerName: "Échéance (quand)", flex: 1, minWidth: 150, sortable: false,
      renderCell: (params) => {
        const quand = params.row.alerte.quand?.trim();
        if (!quand) return <Chip label="Non défini" color="default" size="small" />;
        const isoDate = new Date(quand);
        if (!isNaN(isoDate)) {
          return (
            <Chip
              label={isoDate.toLocaleDateString("fr-FR")}
              size="small"
              color={isoDate < new Date() ? "error" : "success"}
              variant="outlined"
            />
          );
        }
        return <Chip label={quand} size="small" color="info" sx={{ bgcolor: "#e3f2fd", color: "#1565c0" }} />;
      },
    },
    {
      field: "label", headerName: "Nom", flex: 1, minWidth: 150, sortable: false,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Typography
            variant="body2" fontWeight={500} color="text.primary"
            sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pr: 1 }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    { field: "numero", headerName: "Numéro", flex: 1, minWidth: 130, sortable: false },
    {
      field: "created_at", headerName: "Créée le", flex: 1, minWidth: 130, sortable: true,
      renderCell: (params) =>
        params.value ? new Date(params.value).toLocaleDateString("fr-FR") : "-",
    },
    {
      field: "actions", headerName: "Actions", width: 200, sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.75, alignItems: "center" }}>
          <Tooltip
            title={
              params.row.type === "contrat" ? "Résilier" :
                `Résilier ${params.row.type === "marque" ? "la marque" : params.row.type === "brevet" ? "le brevet" : "le domaine"}`
            }
          >
            <ActionIconButton colorhex="#e57373" size="small" onClick={() => handleResiliationClick(params.row)}>
              <CancelOutlinedIcon sx={{ fontSize: 16 }} />
            </ActionIconButton>
          </Tooltip>

          <Tooltip
            title={
              params.row.type === "marque" ? "Renouveler la marque (+10 ans)" :
                params.row.type === "brevet" ? "Renouveler le brevet (+20 ans)" :
                  params.row.type === "domaine" ? "Renouveler le domaine (+1 an)" :
                    "Renouveler le contrat"
            }
          >
            <ActionIconButton colorhex="#2a5fa9" size="small" onClick={() => handleRenouvellementClick(params.row)}>
              <AutorenewIcon sx={{ fontSize: 16 }} />
            </ActionIconButton>
          </Tooltip>
          <Tooltip title="Modifier">
            <ActionIconButton
              colorhex="#4caf50"
              size="small"
              onClick={() => handleEditClick(params.row)}            >
              <EditIcon sx={{ fontSize: 16 }} />
            </ActionIconButton>
          </Tooltip>

          <Tooltip title="Supprimer cette alerte">
            <ActionIconButton colorhex="#757575" size="small" onClick={() => handleDeleteClick(params.row)}>
              <Delete sx={{ fontSize: 16 }} />
            </ActionIconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const tabs = [
    { label: "Marques", icon: <GradientIcon IconComponent={Copyright} />, data: dataByType.marques },
    { label: "Brevets", icon: <GradientIcon IconComponent={AccountBalance} />, data: dataByType.brevets },
    { label: "Contrats", icon: <GradientIcon IconComponent={AccountBalanceWallet} />, data: dataByType.contrats },
    { label: "Domaines", icon: <GradientIcon IconComponent={Language} />, data: dataByType.domaines },
  ];

  // ─── Rendu ────────────────────────────────────────────────────────────────

  return (
    <Box m={2} sx={{ minHeight: "100vh" }}>
      <Header title="Gestion des Alertes" subtitle="Vue détaillée par type d'alerte" />

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <StyledCard elevation={6}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 3 }}>
          <TextField
            size="small"
            placeholder="Rechercher dans toutes les alertes..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{ startAdornment: <Search sx={{ color: "text.secondary", mr: 1 }} /> }}
            sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: "8px", flex: 1 }}
          />
          <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 240 }, flex: { xs: 1, sm: "0 0 240px" } }}>
            <InputLabel>Toutes les sociétés</InputLabel>
            <Select
              value={societeFilter}
              label="Toutes les sociétés"
              onChange={(e) => setSocieteFilter(e.target.value)}
              disabled={loadingSocietes}
              sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: "8px" }}
            >
              <MenuItem value="">Toutes les sociétés</MenuItem>
              {societes.map((soc) => (
                <MenuItem key={soc.id} value={soc.id}>{soc.nom}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>

        <Tabs value={tabValue} onChange={(_, v) => setTabValue(v)} sx={{ mb: 2 }}>
          {tabs.map((tab, i) => (
            <Tab key={i} icon={tab.icon} label={`${tab.label} (${tab.data.length})`} sx={{ fontWeight: 600, textTransform: "none" }} />
          ))}
        </Tabs>

        {tabs.map((tab, i) => (
          <Box key={i} role="tabpanel" hidden={tabValue !== i} sx={{ mt: 2 }}>
            {tabValue === i && (
              <Box sx={{ width: "100%" }}>

                {/* ── Bouton téléchargement PDF ── */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.5 }}>
                  <Button
                    variant="outlined"
                    startIcon={<Download />}
                    onClick={() => handleDownloadPDF(tab.label, tab.data)}
                    sx={{
                      borderRadius: "10px",
                      fontWeight: 600,
                      textTransform: "none",
                      borderColor: alpha("#2a5fa9", 0.4),
                      color: "#2a5fa9",
                      "&:hover": {
                        backgroundColor: alpha("#2a5fa9", 0.07),
                        borderColor: "#2a5fa9",
                      },
                    }}
                  >
                    Télécharger PDF ({tab.label})
                  </Button>
                </Box>

                <StyledDataGrid
                  rows={tab.data}
                  columns={baseColumns}
                  getRowId={(row) => row.id}
                  loading={isLoading || loadingSocietes}
                  pageSizeOptions={[10, 25, 50]}
                  disableColumnMenu
                  localeText={{ noRowsLabel: "Aucune alerte trouvée" }}
                  // autoHeight={true}  
                  sx={{ "& .MuiDataGrid-virtualScroller": { overflowX: "auto" }, height: 500, }}
                />
              </Box>
            )}
          </Box>
        ))}
      </StyledCard>

      {/* ── Modale suppression améliorée ── */}
      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "18px",
            overflow: "hidden",
            boxShadow: `0 24px 60px ${alpha("#e57373", 0.18)}`,
          },
        }}
      >
        {/* Bandeau rouge */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #c62828 0%, #e53935 50%, #ef5350 100%)",
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                bgcolor: alpha("#fff", 0.15),
                borderRadius: "50%",
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Delete sx={{ color: "#fff", fontSize: 22 }} />
            </Box>
            <Typography fontWeight={700} fontSize="1.1rem" color="#fff">
              Supprimer la relation
            </Typography>
          </Box>
          <IconButton
            onClick={() => setOpenDelete(false)}
            sx={{ color: "#fff", opacity: 0.8, "&:hover": { opacity: 1, bgcolor: alpha("#fff", 0.1) } }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
          {/* Avertissement */}
          <Box
            sx={{
              bgcolor: alpha("#e53935", 0.06),
              border: `1px solid ${alpha("#e53935", 0.2)}`,
              borderRadius: "12px",
              p: 2,
              mb: 2.5,
              display: "flex",
              gap: 1.5,
              alignItems: "flex-start",
            }}
          >
            <Typography fontSize="1.25rem" lineHeight={1.2} sx={{ flexShrink: 0 }}>⚠️</Typography>
            <Typography variant="body2" color="text.secondary" lineHeight={1.7}>
              Cette action est{" "}
              <strong style={{ color: "#c62828" }}>irréversible</strong>.
              Êtes-vous sûr(e) de vouloir supprimer cette alerte ?
            </Typography>
          </Box>

        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2.5, gap: 1.5 }}>
          <Button
            onClick={() => setOpenDelete(false)}
            variant="outlined"
            fullWidth
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              fontWeight: 600,
              borderColor: alpha(theme.palette.divider, 0.5),
              color: "text.secondary",
              "&:hover": { borderColor: "text.secondary", bgcolor: "transparent" },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            fullWidth
            startIcon={<Delete fontSize="small" />}
            sx={{
              textTransform: "none",
              borderRadius: "10px",
              fontWeight: 700,
              background: "linear-gradient(135deg, #c62828 0%, #e53935 100%)",
              boxShadow: `0 4px 14px ${alpha("#e53935", 0.4)}`,
              "&:hover": {
                background: "linear-gradient(135deg, #b71c1c 0%, #c62828 100%)",
                boxShadow: `0 6px 20px ${alpha("#e53935", 0.5)}`,
              },
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}

      {editType === "marque" && (
        <Dialog
          open={openEdit && editType === "marque"}
          onClose={handleCloseEdit}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.98)} 0%, ${alpha(
                theme.palette.background.paper,
                0.95
              )} 100%)`,
              backdropFilter: "blur(20px)",
              borderRadius: "20px",
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
            },
          }}
        >
          <DialogTitle sx={{ pb: 2 }}>
            <SectionTitle>Modifier Marque</SectionTitle>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Modifiez les informations de la marque
            </Typography>
          </DialogTitle>

          <Divider sx={{ mb: 2 }} />

          <DialogContent sx={{ pt: 2 }}>
            {/* Section: Informations Générales */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📋</span> Informations Générales
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                <TextField
                  label="Numéro *"
                  fullWidth
                  name="Numéro"
                  value={selectedMarque?.numero || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, numero: e.target.value })}
                  error={submitAttemptedEdit && !selectedMarque?.numero?.trim()}
                  helperText={
                    submitAttemptedEdit && !selectedMarque?.numero?.trim()
                      ? "Ce champ est requis"
                      : ""
                  }
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />

                <FormControl
                  fullWidth
                  error={submitAttemptedEdit && !selectedMarque.societe_id}
                >
                  <InputLabel id="societe-edit-label">Société *</InputLabel>
                  <Select
                    labelId="societe-edit-label"
                    value={selectedMarque?.societe_id || ""}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, societe_id: e.target.value })}
                    label="Société *"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" }
                    }}
                  >
                    <MenuItem value="" disabled>
                      Choisir une société
                    </MenuItem>
                    {societes.map((societe) => (
                      <MenuItem key={societe.id} value={societe.id}>
                        {societe.nom}
                      </MenuItem>
                    ))}
                  </Select>
                  {submitAttemptedEdit && !selectedMarque.societe_id && (
                    <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5 }}>
                      Veuillez sélectionner une société.
                    </Typography>
                  )}
                </FormControl>


                <TextField
                  label="Compte Comptable *"
                  fullWidth
                  name="compte_comptable"
                  value={selectedMarque?.compte_comptable || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, compte_comptable: e.target.value })}
                  error={submitAttemptedEdit && !selectedMarque?.compte_comptable?.trim()}
                  helperText={
                    submitAttemptedEdit && !selectedMarque?.compte_comptable?.trim()
                      ? "Ce champ est requis"
                      : ""
                  }
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Nom"
                  fullWidth
                  value={selectedMarque?.nom || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, nom: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Descriptif"
                  fullWidth
                  value={selectedMarque?.descriptif || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, descriptif: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Numéro Marque"
                  fullWidth
                  value={selectedMarque?.numero_marque || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, numero_marque: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Parties Prenantes */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>👥</span> Parties Prenantes
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                {/* PROPRIÉTAIRE EDIT */}
                {!customProprietaireEdit ? (
                  <FormControl fullWidth>
                    <InputLabel id="proprietaire-edit-label">Propriétaire</InputLabel>
                    <Select
                      labelId="proprietaire-edit-label"
                      value={selectedMarque?.proprietaire || ""}
                      onChange={(e) => setSelectedMarque({ ...selectedMarque, proprietaire: e.target.value })}
                      label="Propriétaire"
                      sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: "12px" }}
                    >
                      <MenuItem value=""><em>Aucun</em></MenuItem>
                      {uniqueProprietaires.map((proprietaire) => (
                        <MenuItem key={proprietaire} value={proprietaire}>{proprietaire}</MenuItem>
                      ))}
                      <Divider />
                      <MenuItem
                        onClick={(e) => { e.stopPropagation(); setCustomProprietaireEdit(true); setSelectedMarque({ ...selectedMarque, proprietaire: "" }); }}
                        sx={{
                          mx: 0.5, borderRadius: '8px',
                          color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                          display: 'flex', alignItems: 'center', gap: 1,
                          '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                        }}
                      >
                        <Box sx={{
                          width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                          background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                        }}>+</Box>
                        Saisir manuellement
                      </MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    label="Propriétaire"
                    fullWidth
                    autoFocus
                    value={selectedMarque?.proprietaire || ""}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, proprietaire: e.target.value })}
                    sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), '& .MuiOutlinedInput-root': { borderRadius: "12px" } }}
                    InputProps={{
                      endAdornment: (
                        <Button size="small" onClick={() => { setCustomProprietaireEdit(false); setSelectedMarque({ ...selectedMarque, proprietaire: "" }); }}
                          sx={{ color: "error.main", minWidth: 'auto', fontSize: '0.75rem' }}>
                          ✕
                        </Button>
                      )
                    }}
                  />
                )}

                {/* MANDATAIRE EDIT */}
                {!customMandataireEdit ? (
                  <FormControl fullWidth>
                    <InputLabel id="mandataire-edit-label">Mandataire</InputLabel>
                    <Select
                      labelId="mandataire-edit-label"
                      value={selectedMarque?.mandataire || ""}
                      onChange={(e) => setSelectedMarque({ ...selectedMarque, mandataire: e.target.value })}
                      label="Mandataire"
                      sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: "12px" }}
                    >
                      <MenuItem value=""><em>Aucun</em></MenuItem>
                      {uniqueMandataires.map((mandataire) => (
                        <MenuItem key={mandataire} value={mandataire}>{mandataire}</MenuItem>
                      ))}
                      <Divider />
                      <MenuItem
                        onClick={(e) => { e.stopPropagation(); setCustomMandataireEdit(true); setSelectedMarque({ ...selectedMarque, mandataire: "" }); }}
                        sx={{
                          mx: 0.5, borderRadius: '8px',
                          color: '#2a5fa9', fontWeight: 600, fontSize: '0.875rem',
                          display: 'flex', alignItems: 'center', gap: 1,
                          '&:hover': { backgroundColor: alpha('#2a5fa9', 0.08) },
                        }}
                      >
                        <Box sx={{
                          width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                          background: 'linear-gradient(135deg, #2a5fa9, #4cbed8)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: '#fff', fontSize: '1.1rem', fontWeight: 700,
                        }}>+</Box>
                        Saisir manuellement
                      </MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    label="Mandataire"
                    fullWidth
                    autoFocus
                    value={selectedMarque?.mandataire || ""}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, mandataire: e.target.value })}
                    sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), '& .MuiOutlinedInput-root': { borderRadius: "12px" } }}
                    InputProps={{
                      endAdornment: (
                        <Button size="small" onClick={() => { setCustomMandataireEdit(false); setSelectedMarque({ ...selectedMarque, mandataire: "" }); }}
                          sx={{ color: "error.main", minWidth: 'auto', fontSize: '0.75rem' }}>
                          ✕
                        </Button>
                      )
                    }}
                  />
                )}

              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Surveillance */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>🔍</span> Surveillance
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedMarque?.surveillance_externe || false}
                      onChange={(e) => setSelectedMarque({ ...selectedMarque, surveillance_externe: e.target.checked })}
                      sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }}
                    />
                  }
                  label={
                    <Typography variant="body1" sx={{ ml: 1 }}>
                      Surveillance Externe
                    </Typography>
                  }
                  sx={{
                    ml: 0,
                    p: 2,
                    borderRadius: "12px",
                    backgroundColor: alpha(theme.palette.primary.main, 0.05),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="cabinet-surveilleur-edit-label">Cabinet Surveilleur</InputLabel>
                  <Select
                    labelId="cabinet-surveilleur-edit-label"
                    value={selectedMarque?.cabinet_surveilleur || ""}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, cabinet_surveilleur: e.target.value })}
                    label="Cabinet Surveilleur"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value="">
                      <em>Aucun</em>
                    </MenuItem>
                    {uniqueCabinetsSurveilleurs.map((cabinet) => (
                      <MenuItem key={cabinet} value={cabinet}>
                        {cabinet}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  label="Numéro Dossier Surveilleur"
                  fullWidth
                  value={selectedMarque?.numero_dossier_surveilleur || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, numero_dossier_surveilleur: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Classification */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>🏷️</span> Classification et Protection
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <FormControl
                  fullWidth
                  error={submitAttemptedEdit && !selectedMarque?.classes?.length}
                >
                  <InputLabel id="classes-edit-label">Classes *</InputLabel>
                  <Select
                    labelId="classes-edit-label"
                    multiple
                    open={isClassesSelectOpen}
                    onOpen={() => setIsClassesSelectOpen(true)}
                    onClose={() => setIsClassesSelectOpen(false)}
                    value={selectedMarque?.classes || []}
                    onChange={(e) => {
                      const validValues = e.target.value.filter(val => val !== undefined && val !== null && val !== '');
                      setSelectedMarque({ ...selectedMarque, classes: [...new Set(validValues)] });
                    }}
                    renderValue={(selected) =>
                      selected.length
                        ? selected
                          .map((id) => {
                            const classe = classes.find((c) => c.id === id);
                            return classe ? `${classe.numero} - ${classe.intitule}` : null;
                          })
                          .filter(Boolean)
                          .join(", ")
                        : "Aucune classe sélectionnée"
                    }
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    {classes.length ? (
                      classes.map((classe) => (
                        <MenuItem key={classe.id} value={classe.id}>
                          <Checkbox checked={(selectedMarque?.classes || []).includes(classe.id)} />
                          <ListItemText primary={`${classe.numero || "N/A"} - ${classe.intitule || "N/A"}`} />
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Aucune classe disponible</MenuItem>
                    )}
                    <MenuItem>
                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        onClick={() => setIsClassesSelectOpen(false)}
                        sx={{ mt: 1 }}
                      >
                        Fermer
                      </Button>
                    </MenuItem>
                  </Select>
                  {submitAttemptedEdit && !selectedMarque?.classes?.length && (
                    <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5, display: 'block' }}>
                      Veuillez sélectionner au moins une classe.
                    </Typography>
                  )}
                </FormControl>


                <FormControl
                  fullWidth
                  error={submitAttemptedEdit && !selectedMarque?.zone_de_protection?.length}
                >
                  <InputLabel id="zone-protection-edit-label">Zones de Protection *</InputLabel>
                  <Select
                    labelId="zone-protection-edit-label"
                    multiple
                    value={selectedMarque?.zone_de_protection || []}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, zone_de_protection: [...new Set(e.target.value)] })}
                    renderValue={(selected) =>
                      Array.isArray(selected) && selected.length
                        ? selected.join(", ")
                        : "Aucune zone sélectionnée"
                    }
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    {protectionZones.map((zone) => (
                      <MenuItem key={zone.id} value={zone.name}>
                        <Checkbox checked={(selectedMarque?.zone_de_protection || []).includes(zone.name)} />
                        <ListItemText primary={zone.name} />
                      </MenuItem>
                    ))}
                  </Select>
                  {submitAttemptedEdit && !selectedMarque?.zone_de_protection?.length && (
                    <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5, display: 'block' }}>
                      Veuillez sélectionner au moins une zone de protection.
                    </Typography>
                  )}
                </FormControl>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Documents */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📄</span> Documents
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <Box>
                  <TextField
                    label="Certificat Dépôt PDF"
                    type="file"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ accept: "application/pdf" }}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, certificat_depot_pdf: e.target.files[0] })}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': {
                        borderRadius: "12px",
                      }
                    }}
                  />
                  {selectedMarque?.existing_certificat_depot_pdf && (
                    <Box display="flex" alignItems="center" sx={{
                      mt: 1.5,
                      p: 1.5,
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.info.main, 0.05),
                      border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`
                    }}>
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1 }}>
                        📎 Fichier actuel : {selectedMarque.existing_certificat_depot_pdf.split("/").pop()}
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Download />}
                        sx={{
                          ml: 2,
                          borderRadius: "8px",
                          borderColor: alpha(theme.palette.primary.main, 0.3),
                          color: theme.palette.primary.main,
                          "&:hover": {
                            backgroundColor: alpha(theme.palette.primary.main, 0.1),
                            borderColor: theme.palette.primary.main,
                          },
                        }}
                        onClick={() =>
                          window.open(
                            `${process.env.REACT_APP_API_URL}/storage/certificats/${selectedMarque.existing_certificat_depot_pdf.split("/").pop()}`,
                            "_blank"
                          )
                        }
                      >
                        Télécharger
                      </Button>
                    </Box>
                  )}
                </Box>

                <Box>
                  <TextField
                    label="Certificat Enregistrement PDF"
                    type="file"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ accept: "application/pdf" }}
                    onChange={(e) => setSelectedMarque({ ...selectedMarque, certificat_enregistrement_pdf: e.target.files[0] })}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': {
                        borderRadius: "12px",
                      }
                    }}
                  />
                  {selectedMarque?.existing_certificat_enregistrement_pdf && (
                    <Box display="flex" alignItems="center" sx={{
                      mt: 1.5,
                      p: 1.5,
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.info.main, 0.05),
                      border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`
                    }}>
                      <Typography variant="body2" color="textSecondary" sx={{ flex: 1 }}>
                        📎 Fichier actuel : {selectedMarque.existing_certificat_enregistrement_pdf.split("/").pop()}
                      </Typography>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Download />}
                        sx={{
                          ml: 2,
                          borderRadius: "8px",
                          borderColor: alpha(theme.palette.primary.main, 0.3),
                          color: theme.palette.primary.main,
                          "&:hover": {
                            backgroundColor: alpha(theme.palette.primary.main, 0.1),
                            borderColor: theme.palette.primary.main,
                          },
                        }}
                        onClick={() =>
                          window.open(
                            `${process.env.REACT_APP_API_URL}/storage/certificats/${selectedMarque.existing_certificat_enregistrement_pdf.split("/").pop()}`,
                            "_blank"
                          )
                        }
                      >
                        Télécharger
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Dates */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📅</span> Dates Importantes
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  label="Date Dépôt"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedMarque?.date_depot || ""}
                  onChange={(e) => {
                    const { date_de_protection, date_de_renouvellement } = calculateDerivedDates(
                      e.target.value,
                      selectedMarque.date_de_publication
                    );
                    setSelectedMarque({
                      ...selectedMarque,
                      date_depot: e.target.value,
                      date_de_protection,
                      date_de_renouvellement,
                    });
                  }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Date Publication"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedMarque?.date_de_publication || ""}
                  onChange={(e) => {
                    const { date_de_fin_opposition } = calculateDerivedDates(selectedMarque.date_depot, e.target.value);
                    setSelectedMarque({
                      ...selectedMarque,
                      date_de_publication: e.target.value,
                      date_de_fin_opposition,
                    });
                  }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Date Fin Opposition"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedMarque?.date_de_fin_opposition || ""}
                  InputProps={{ readOnly: true }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Date Protection"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedMarque?.date_de_protection || ""}
                  InputProps={{ readOnly: true }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Date Renouvellement"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedMarque?.date_de_renouvellement || ""}
                  InputProps={{ readOnly: true }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Informations Complémentaires */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>ℹ️</span> Informations Complémentaires
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  select
                  label="État de la Marque"
                  fullWidth
                  value={selectedMarque?.etat_de_la_marque || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, etat_de_la_marque: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                >
                  {etatsDisponibles.map((etat) => (
                    <MenuItem key={etat} value={etat}>
                      {etat}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Noms Domaine Associés"
                  fullWidth
                  value={selectedMarque?.noms_domaine_associes || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, noms_domaine_associes: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
                <TextField
                  label="Commentaire"
                  fullWidth
                  multilinea
                  rows={3}
                  value={selectedMarque?.commentaire || ""}
                  onChange={(e) => setSelectedMarque({ ...selectedMarque, commentaire: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': {
                      borderRadius: "12px",
                    }
                  }}
                />
              </Box>
            </Box>
          </DialogContent>

          <Divider sx={{ mt: 2 }} />

          <DialogActions sx={{ px: 3, py: 2.5, gap: 1.5 }}>
            <Button
              onClick={() => {
                setOpenEdit(false);
                setSubmitAttemptedEdit(false);
                setCustomProprietaireEdit(false);
                setCustomMandataireEdit(false);
              }} sx={{
                color: theme.palette.error.main,
                borderRadius: "10px",
                px: 3,
                py: 1,
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleEditSubmit}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "10px",
                px: 4,
                py: 1,
                fontWeight: 600,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                "&:hover": {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                  transform: "translateY(-2px)",
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                transition: "all 0.3s ease",
              }}
            >
              Enregistrer
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Edit Dialog - Brevet */}
      {editType === "brevet" && (
        <Dialog
          open={openEdit && editType === "brevet"}
          onClose={handleCloseEdit}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.98)} 0%, ${alpha(
                theme.palette.background.paper,
                0.95
              )} 100%)`,
              backdropFilter: "blur(20px)",
              borderRadius: "20px",
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
            },
          }}
        >
          <DialogTitle sx={{ pb: 2 }}>
            <SectionTitle>Modifier un Brevet</SectionTitle>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Modifiez les informations du brevet sélectionné
            </Typography>
          </DialogTitle>

          <Divider sx={{ mb: 2 }} />

          <DialogContent sx={{ pt: 2 }}>
            {/* Copiez ici tout le contenu du dialogue d'édition des brevets depuis Brevets.js */}
            {/* Section: Informations Générales */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📋</span> Informations Générales
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  id="Code_Famille_CEGID_edit"
                  label="Code Famille"
                  fullWidth
                  required
                  value={selectedBrevet?.Code_Famille_CEGID || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, Code_Famille_CEGID: e.target.value })}
                  error={!!brevetFormErrors.Code_Famille_CEGID}
                  helperText={brevetFormErrors.Code_Famille_CEGID}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <FormControl fullWidth error={!!brevetFormErrors.societe_id}>
                  <InputLabel id="societe-edit-label-brevet">Société *</InputLabel>
                  <Select
                    labelId="societe-edit-label-brevet"
                    value={selectedBrevet?.societe_id || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, societe_id: e.target.value })}
                    label="Société *"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" }
                    }}
                  >
                    <MenuItem value=""><em>Choisir une société</em></MenuItem>
                    {societes.map((soc) => (
                      <MenuItem key={soc.id} value={soc.id}>{soc.nom}</MenuItem>
                    ))}
                  </Select>
                  {brevetFormErrors.societe_id && (
                    <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                      {brevetFormErrors.societe_id}
                    </Typography>
                  )}
                </FormControl>

                <TextField
                  id="nom_edit"
                  label="Nom"
                  fullWidth
                  required
                  value={selectedBrevet?.nom || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, nom: e.target.value })}
                  error={!!brevetFormErrors.nom}
                  helperText={brevetFormErrors.nom}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  id="compte_comptable_edit"
                  label="Compte Comptable"
                  fullWidth
                  required
                  value={selectedBrevet?.compte_comptable || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, compte_comptable: e.target.value })}
                  error={!!brevetFormErrors.compte_comptable}
                  helperText={brevetFormErrors.compte_comptable}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Descriptif"
                  fullWidth
                  multiline
                  rows={2}
                  value={selectedBrevet?.descriptif || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, descriptif: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Numéro Brevet"
                  fullWidth
                  value={selectedBrevet?.numero_brevet || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, numero_brevet: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Numéro Dossier"
                  fullWidth
                  value={selectedBrevet?.numero_dossier || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, numero_dossier: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Parties Prenantes */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>👥</span> Parties Prenantes
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  label="Mandataire"
                  fullWidth
                  value={selectedBrevet?.mandataire || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, mandataire: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="inventeur-edit-label">Inventeur</InputLabel>
                  <Select
                    labelId="inventeur-edit-label"
                    value={selectedBrevet?.inventeur || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, inventeur: e.target.value })}
                    label="Inventeur"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner un inventeur</em></MenuItem>
                    {inventeurs.map((inv) => (
                      <MenuItem key={inv} value={inv}>{inv}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    label="Nouvel inventeur"
                    fullWidth
                    value={newInventeur}
                    onChange={(e) => setNewInventeur(e.target.value)}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (newInventeur.trim() && !inventeurs.includes(newInventeur.trim())) {
                        setInventeurs([...inventeurs, newInventeur.trim()]);
                        setSelectedBrevet({ ...selectedBrevet, inventeur: newInventeur.trim() });
                        setNewInventeur("");
                      }
                    }}
                    disabled={!newInventeur.trim()}
                    sx={{ borderRadius: "12px" }}
                  >
                    Ajouter
                  </Button>
                </Box>

                <FormControl fullWidth>
                  <InputLabel id="titulaire-edit-label">Titulaire</InputLabel>
                  <Select
                    labelId="titulaire-edit-label"
                    value={selectedBrevet?.titulaire || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, titulaire: e.target.value })}
                    label="Titulaire"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner un titulaire</em></MenuItem>
                    {titulaires.map((tit) => (
                      <MenuItem key={tit} value={tit}>{tit}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    label="Nouveau titulaire"
                    fullWidth
                    value={newTitulaire}
                    onChange={(e) => setNewTitulaire(e.target.value)}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (newTitulaire.trim() && !titulaires.includes(newTitulaire.trim())) {
                        setTitulaires([...titulaires, newTitulaire.trim()]);
                        setSelectedBrevet({ ...selectedBrevet, titulaire: newTitulaire.trim() });
                        setNewTitulaire("");
                      }
                    }}
                    disabled={!newTitulaire.trim()}
                    sx={{ borderRadius: "12px" }}
                  >
                    Ajouter
                  </Button>
                </Box>

                <FormControl fullWidth>
                  <InputLabel id="debiteur-edit-label">Débiteur Annuités</InputLabel>
                  <Select
                    labelId="debiteur-edit-label"
                    value={selectedBrevet?.debiteur_annuites || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, debiteur_annuites: e.target.value })}
                    label="Débiteur Annuités"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner un débiteur</em></MenuItem>
                    {debiteurs.map((deb) => (
                      <MenuItem key={deb} value={deb}>{deb}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    label="Nouveau débiteur"
                    fullWidth
                    value={newDebiteur}
                    onChange={(e) => setNewDebiteur(e.target.value)}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (newDebiteur.trim() && !debiteurs.includes(newDebiteur.trim())) {
                        setDebiteurs([...debiteurs, newDebiteur.trim()]);
                        setSelectedBrevet({ ...selectedBrevet, debiteur_annuites: newDebiteur.trim() });
                        setNewDebiteur("");
                      }
                    }}
                    disabled={!newDebiteur.trim()}
                    sx={{ borderRadius: "12px" }}
                  >
                    Ajouter
                  </Button>
                </Box>

                <FormControl fullWidth>
                  <InputLabel id="ayant-droit-edit-label">Ayant Droit</InputLabel>
                  <Select
                    labelId="ayant-droit-edit-label"
                    value={selectedBrevet?.ayant_droit || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, ayant_droit: e.target.value })}
                    label="Ayant Droit"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner un ayant droit</em></MenuItem>
                    {ayantsDroit.map((ayant) => (
                      <MenuItem key={ayant} value={ayant}>{ayant}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TextField
                    label="Nouvel ayant droit"
                    fullWidth
                    value={newAyantDroit}
                    onChange={(e) => setNewAyantDroit(e.target.value)}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (newAyantDroit.trim() && !ayantsDroit.includes(newAyantDroit.trim())) {
                        setAyantsDroit([...ayantsDroit, newAyantDroit.trim()]);
                        setSelectedBrevet({ ...selectedBrevet, ayant_droit: newAyantDroit.trim() });
                        setNewAyantDroit("");
                      }
                    }}
                    disabled={!newAyantDroit.trim()}
                    sx={{ borderRadius: "12px" }}
                  >
                    Ajouter
                  </Button>
                </Box>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Zone de Protection */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>🏷️</span> Zone de Protection
              </Typography>
              <FormControl fullWidth margin="dense" error={!!brevetFormErrors.pays}>
                <InputLabel id="pays-select-edit-label">Pays *</InputLabel>
                <Select
                  id="pays_edit"
                  labelId="pays-select-edit-label"
                  multiple
                  value={selectedBrevet?.pays || []}
                  onChange={(event) => setSelectedBrevet({ ...selectedBrevet, pays: event.target.value })}
                  input={<OutlinedInput id="select-pays-edit" label="Pays *" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {(Array.isArray(selected) ? selected : []).map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    borderRadius: '12px',
                    '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                  }}
                >
                  {countries.map((country) => (
                    <MenuItem key={country} value={country}>{country}</MenuItem>
                  ))}
                </Select>
                {brevetFormErrors.pays && <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>{brevetFormErrors.pays}</Typography>}
              </FormControl>

              <Box display="flex" alignItems="center" mt={1}>
                <TextField
                  label="Nouveau pays"
                  value={newCountry}
                  onChange={(e) => setNewCountry(e.target.value)}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    borderRadius: '12px',
                    mr: 1,
                    '& .MuiOutlinedInput-root': { borderRadius: '12px' }
                  }}
                />
                <Button
                  variant="contained"
                  onClick={() => {
                    if (newCountry.trim() && !countries.includes(newCountry.trim().toUpperCase())) {
                      setCountries([...countries, newCountry.trim().toUpperCase()]);
                      setSelectedBrevet({
                        ...selectedBrevet,
                        pays: [...(selectedBrevet?.pays || []), newCountry.trim().toUpperCase()]
                      });
                      setNewCountry("");
                    }
                  }}
                  disabled={!newCountry.trim()}
                  sx={{ borderRadius: '12px' }}
                >
                  Ajouter
                </Button>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Royalties */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>💰</span> Royalties
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <FormControl fullWidth>
                  <InputLabel id="type-royalties-edit-label">Type de Royalties</InputLabel>
                  <Select
                    labelId="type-royalties-edit-label"
                    value={selectedBrevet?.type_royalties || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, type_royalties: e.target.value })}
                    label="Type de Royalties"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner un type</em></MenuItem>
                    {royaltyTypes.map((type) => (
                      <MenuItem key={type} value={type}>{type}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  label="Montant des Royalties"
                  type="number"
                  fullWidth
                  value={selectedBrevet?.montant_royalties || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, montant_royalties: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="frequence-royalties-edit-label">Fréquence des Royalties</InputLabel>
                  <Select
                    labelId="frequence-royalties-edit-label"
                    value={selectedBrevet?.frequence_royalties || ""}
                    onChange={(e) => setSelectedBrevet({ ...selectedBrevet, frequence_royalties: e.target.value })}
                    label="Fréquence des Royalties"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner une fréquence</em></MenuItem>
                    {royaltyFrequencies.map((freq) => (
                      <MenuItem key={freq} value={freq}>{freq}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Documents */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📄</span> Documents
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <Box>
                  <Typography variant="body1">
                    Certificat Dépôt PDF actuel :{" "}
                    {selectedBrevet?.certificat_depot_pdf ? (
                      <a
                        href={`${process.env.REACT_APP_API_URL}/storage/certificats/${selectedBrevet.certificat_depot_pdf.split('/').pop()}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {selectedBrevet.certificat_depot_pdf.split('/').pop()}
                      </a>
                    ) : (
                      "Aucun"
                    )}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Laisser vide pour conserver le fichier actuel.
                  </Typography>
                  <TextField
                    type="file"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ accept: "application/pdf" }}
                    onChange={(e) => setSelectedCertificatDepotFile(e.target.files[0] || null)}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                </Box>

                <Box>
                  <Typography variant="body1">
                    Certificat Enregistrement PDF actuel :{" "}
                    {selectedBrevet?.certificat_enregistrement_pdf ? (
                      <a
                        href={`${process.env.REACT_APP_API_URL}/storage/certificats/${selectedBrevet.certificat_enregistrement_pdf.split('/').pop()}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {selectedBrevet.certificat_enregistrement_pdf.split('/').pop()}
                      </a>
                    ) : (
                      "Aucun"
                    )}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Laisser vide pour conserver le fichier actuel.
                  </Typography>
                  <TextField
                    type="file"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ accept: "application/pdf" }}
                    onChange={(e) => setSelectedCertificatEnregistrementFile(e.target.files[0] || null)}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Dates */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📅</span> Dates Importantes
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  id="date_depot_edit"
                  label="Date Dépôt"
                  type="date"
                  fullWidth
                  required
                  InputLabelProps={{ shrink: true }}
                  value={selectedBrevet?.date_depot || ""}
                  onChange={handleEditDateDepotChange}
                  error={!!brevetFormErrors.date_depot}
                  helperText={brevetFormErrors.date_depot}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Date Publication"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedBrevet?.date_publication || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, date_publication: e.target.value })}
                  helperText="Auto-calculé : Dépôt + 18 mois"
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Date Échéance Annuités"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedBrevet?.date_echeance_annuites || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, date_echeance_annuites: e.target.value })}
                  helperText="Anniversaire annuel du dépôt"
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Échéance"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedBrevet?.date_expiration || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, date_expiration: e.target.value })}
                  helperText="Auto-calculé : Dépôt + 20 ans"
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Informations Complémentaires */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>ℹ️</span> Informations Complémentaires
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  select
                  label="État"
                  fullWidth
                  value={selectedBrevet?.etat || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, etat: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                >
                  {etatsBrevets.map((etat) => (
                    <MenuItem key={etat} value={etat}>{etat}</MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Commentaires"
                  fullWidth
                  multiline
                  rows={3}
                  value={selectedBrevet?.commentaires || ""}
                  onChange={(e) => setSelectedBrevet({ ...selectedBrevet, commentaires: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />
              </Box>
            </Box>
          </DialogContent>

          <Divider sx={{ mt: 2 }} />

          <DialogActions sx={{ px: 3, py: 2.5, gap: 1.5 }}>
            <Button
              onClick={handleCloseEdit}
              sx={{
                color: theme.palette.error.main,
                borderRadius: "10px",
                px: 3,
                py: 1,
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleEditSubmit}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "10px",
                px: 4,
                py: 1,
                fontWeight: 600,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                "&:hover": {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                  transform: "translateY(-2px)",
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                transition: "all 0.3s ease",
              }}
            >
              Enregistrer
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* Edit Dialog - Contrat */}
      {editType === "contrat" && (
        <Dialog
          open={openEdit && editType === "contrat"}
          onClose={() => {
            setOpenEdit(false);
            setEditFichierPdf(null);
          }}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.98)} 0%, ${alpha(
                theme.palette.background.paper,
                0.95
              )} 100%)`,
              backdropFilter: "blur(20px)",
              borderRadius: "20px",
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
            },
          }}
        >
          <DialogTitle sx={{ pb: 2 }}>
            <SectionTitle>Modifier le Contrat</SectionTitle>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Modifiez les informations du contrat sélectionné
            </Typography>
          </DialogTitle>

          <Divider sx={{ mb: 2 }} />

          <DialogContent sx={{ pt: 2 }}>
            {/* Section: Informations Générales */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📋</span> Informations Générales
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  label="N° Contrat"
                  fullWidth
                  value={selectedContrat?.n_contact || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, n_contact: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="societe-contrat-edit-label">Société</InputLabel>
                  <Select
                    labelId="societe-contrat-edit-label"
                    value={selectedContrat?.societe_id || ""}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, societe_id: e.target.value })}
                    label="Société"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value=""><em>Sélectionner une société</em></MenuItem>
                    {allSocietes.map((societe) => (
                      <MenuItem key={societe.id} value={societe.id}>{societe.nom}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  label="Nom Fournisseur"
                  fullWidth
                  value={selectedContrat?.nom_fournisseur || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, nom_fournisseur: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Code Fournisseur"
                  fullWidth
                  value={selectedContrat?.code_fournisseur || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, code_fournisseur: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Compte Comptable"
                  fullWidth
                  value={selectedContrat?.compte_comptable || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, compte_comptable: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Contact Fournisseur */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>👤</span> Contact Fournisseur
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  label="Nom Contact"
                  fullWidth
                  value={selectedContrat?.nom_contact || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, nom_contact: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Téléphone Contact"
                  fullWidth
                  value={selectedContrat?.telephone_contact || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, telephone_contact: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Email Contact"
                  type="email"
                  fullWidth
                  value={selectedContrat?.email_contact || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, email_contact: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Adresse Fournisseur"
                  fullWidth
                  value={selectedContrat?.adresse_fournisseur || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, adresse_fournisseur: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField
                    label="Code Postal"
                    fullWidth
                    value={selectedContrat?.cp_fournisseur || ""}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, cp_fournisseur: e.target.value })}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                  <TextField
                    label="Ville"
                    fullWidth
                    value={selectedContrat?.ville_fournisseur || ""}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, ville_fournisseur: e.target.value })}
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                    }}
                  />
                </Box>

                <TextField
                  label="Pays"
                  fullWidth
                  value={selectedContrat?.pays_fournisseur || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, pays_fournisseur: e.target.value })}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Durée et Échéances */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>⏱️</span> Durée et Échéances
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  label="Date Signature"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedContrat?.date_signature || ""}
                  onChange={(e) => {
                    const fin = calculateFinContrat(e.target.value, selectedContrat?.duree || "");
                    const preavis = calculateDatePreavis(fin, selectedContrat?.delai_preavis || "");
                    setSelectedContrat({
                      ...selectedContrat,
                      date_signature: e.target.value,
                      fin_contrat: fin,
                      date_preavis: preavis,
                    });
                  }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Durée (mois)"
                  type="number"
                  fullWidth
                  value={selectedContrat?.duree || ""}
                  onChange={(e) => {
                    const fin = calculateFinContrat(selectedContrat?.date_signature || "", e.target.value);
                    const preavis = calculateDatePreavis(fin, selectedContrat?.delai_preavis || "");
                    setSelectedContrat({
                      ...selectedContrat,
                      duree: e.target.value,
                      fin_contrat: fin,
                      date_preavis: preavis,
                    });
                  }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Fin Contrat"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedContrat?.fin_contrat || ""}
                  onChange={(e) => {
                    const preavis = calculateDatePreavis(e.target.value, selectedContrat?.delai_preavis || "");
                    setSelectedContrat({
                      ...selectedContrat,
                      fin_contrat: e.target.value,
                      date_preavis: preavis,
                    });
                  }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Délai Préavis (mois)"
                  type="number"
                  fullWidth
                  value={selectedContrat?.delai_preavis || ""}
                  onChange={(e) => {
                    const preavis = calculateDatePreavis(selectedContrat?.fin_contrat || "", e.target.value);
                    setSelectedContrat({
                      ...selectedContrat,
                      delai_preavis: e.target.value,
                      date_preavis: preavis,
                    });
                  }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Date Préavis"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={selectedContrat?.date_preavis || ""}
                  InputProps={{ readOnly: true }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Période de réengagement (mois)"
                  type="number"
                  fullWidth
                  value={selectedContrat?.periode_reengagement || ""}
                  onChange={(e) => {
                    setSelectedContrat({
                      ...selectedContrat,
                      periode_reengagement: e.target.value,
                    });
                  }}
                  InputProps={{ inputProps: { min: 0 } }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Conditions Financières */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>💰</span> Conditions Financières
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                  label="Loyer HT"
                  type="number"
                  fullWidth
                  value={selectedContrat?.loyer_ht || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, loyer_ht: e.target.value })}
                  InputProps={{ inputProps: { min: 0 } }}
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <TextField
                  label="Devise"
                  fullWidth
                  value={selectedContrat?.devise || ""}
                  onChange={(e) => setSelectedContrat({ ...selectedContrat, devise: e.target.value })}
                  placeholder="ex: EUR, USD, TND..."
                  sx={{
                    backgroundColor: alpha(theme.palette.background.paper, 0.95),
                    '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="taux-tva-contrat-edit-label">Taux TVA Loyer (%)</InputLabel>
                  <Select
                    labelId="taux-tva-contrat-edit-label"
                    value={selectedContrat?.taux_tva_loyer || ""}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, taux_tva_loyer: e.target.value })}
                    label="Taux TVA Loyer (%)"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    {tauxTVAOptions.map((taux) => (
                      <MenuItem key={taux} value={taux}>{taux}%</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="periodicite-contrat-edit-label">Périodicité Paiement</InputLabel>
                  <Select
                    labelId="periodicite-contrat-edit-label"
                    value={selectedContrat?.periodicite_paiement || ""}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, periodicite_paiement: e.target.value })}
                    label="Périodicité Paiement"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    {periodicitesPaiement.map((p) => (
                      <MenuItem key={p} value={p}>{p}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Statut et Reconduction */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📌</span> Statut et Reconduction
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <FormControl fullWidth>
                  <InputLabel id="etat-contrat-edit-label">État du Contrat</InputLabel>
                  <Select
                    labelId="etat-contrat-edit-label"
                    value={selectedContrat?.etat || ""}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, etat: e.target.value })}
                    label="État du Contrat"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    {contratEtats.map((etat) => (
                      <MenuItem key={etat} value={etat}>{etat}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="reconduction-contrat-edit-label">Reconduction Tacite</InputLabel>
                  <Select
                    labelId="reconduction-contrat-edit-label"
                    value={selectedContrat?.reconduction_tacite || "non"}
                    onChange={(e) => setSelectedContrat({ ...selectedContrat, reconduction_tacite: e.target.value })}
                    label="Reconduction Tacite"
                    sx={{
                      backgroundColor: alpha(theme.palette.background.paper, 0.95),
                      borderRadius: "12px",
                    }}
                  >
                    <MenuItem value="oui">Oui</MenuItem>
                    <MenuItem value="non">Non</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Détails Complémentaires */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📝</span> Détails Complémentaires
              </Typography>
              <TextField
                label="Détails / Objets du Contrat"
                fullWidth
                multiline
                rows={4}
                value={selectedContrat?.details || ""}
                onChange={(e) => setSelectedContrat({ ...selectedContrat, details: e.target.value })}
                sx={{
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  '& .MuiOutlinedInput-root': { borderRadius: "12px" },
                }}
              />
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* Section: Fichier PDF */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="primary" sx={{ mb: 2.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>📄</span> Fichier Contrat (PDF)
              </Typography>

              {selectedContrat?.fichier_pdf && !editFichierPdf && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    p: 2,
                    mb: 2,
                    borderRadius: "12px",
                    border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                    backgroundColor: alpha(theme.palette.success.main, 0.05),
                  }}
                >
                  <Download sx={{ color: theme.palette.success.main }} />
                  <Box flex={1}>
                    <Typography variant="body2" fontWeight={600} color="success.main">
                      Fichier PDF existant
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {selectedContrat.fichier_pdf.split("/").pop()}
                    </Typography>
                  </Box>
                  <Button
                    size="small"
                    variant="outlined"
                    color="success"
                    onClick={() =>
                      window.open(
                        `${process.env.REACT_APP_API_URL}/storage/contrat/${selectedContrat.fichier_pdf.split("/").pop()}`,
                        "_blank"
                      )
                    }
                  >
                    Voir
                  </Button>
                </Box>
              )}

              <Box
                sx={{
                  border: `2px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
                  borderRadius: "12px",
                  p: 3,
                  textAlign: "center",
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    borderColor: theme.palette.primary.main,
                    backgroundColor: alpha(theme.palette.primary.main, 0.03),
                  },
                }}
                onClick={() => document.getElementById("fichier-pdf-edit-contrat").click()}
              >
                <input
                  id="fichier-pdf-edit-contrat"
                  type="file"
                  accept="application/pdf"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) setEditFichierPdf(file);
                  }}
                />
                <Download sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.5), mb: 1 }} />
                {editFichierPdf ? (
                  <Box>
                    <Typography variant="body2" color="primary" fontWeight={600}>
                      {editFichierPdf.name}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {(editFichierPdf.size / 1024 / 1024).toFixed(2)} Mo
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    <Typography variant="body2" color="textSecondary">
                      {selectedContrat?.fichier_pdf
                        ? "Cliquez pour remplacer le fichier PDF existant"
                        : "Cliquez pour sélectionner un fichier PDF"}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Formats acceptés : PDF uniquement (jusqu'à 50 Mo)
                    </Typography>
                  </Box>
                )}
              </Box>
              {editFichierPdf && (
                <Button
                  size="small"
                  color="error"
                  onClick={() => {
                    setEditFichierPdf(null);
                    document.getElementById("fichier-pdf-edit-contrat").value = "";
                  }}
                  sx={{ mt: 1 }}
                >
                  Annuler le remplacement
                </Button>
              )}
            </Box>

            {isUploading && (
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                  <Typography variant="caption" color="primary" fontWeight={600}>
                    Upload en cours...
                  </Typography>
                  <Typography variant="caption" color="primary" fontWeight={600}>
                    {uploadProgress}%
                  </Typography>
                </Box>
                <Box sx={{
                  width: "100%",
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: alpha(theme.palette.primary.main, 0.15),
                  overflow: "hidden",
                }}>
                  <Box sx={{
                    height: "100%",
                    width: `${uploadProgress}%`,
                    borderRadius: 4,
                    background: "linear-gradient(90deg, #2a5fa9 0%, #3a7fb5 20%, #4a9fc0 40%, #5ab8a0 60%, #70bd8d 80%, #8fc68b 100%)",
                    transition: "width 0.3s ease",
                  }} />
                </Box>
              </Box>
            )}
          </DialogContent>

          <Divider sx={{ mt: 2 }} />

          <DialogActions sx={{ px: 3, py: 2.5, gap: 1.5 }}>
            <Button
              onClick={() => {
                setOpenEdit(false);
                setEditFichierPdf(null);
              }}
              sx={{
                color: theme.palette.error.main,
                borderRadius: "10px",
                px: 3,
                py: 1,
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleEditSubmit}
              disabled={isUploading}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "10px",
                px: 4,
                py: 1,
                fontWeight: 600,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                "&:hover": {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                  transform: "translateY(-2px)",
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                transition: "all 0.3s ease",
              }}
            >
              {isUploading ? "Upload..." : "Enregistrer"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Edit Dialog - Domaine */}
      {editType === "domaine" && (
        <Dialog
          open={openEdit && editType === "domaine"}
          onClose={handleCloseEdit}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.98)} 0%, ${alpha(
                theme.palette.background.paper,
                0.95
              )} 100%)`,
              backdropFilter: "blur(20px)",
              borderRadius: "20px",
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
            },
          }}
        >
          <DialogTitle sx={{ pb: 2 }}>
            <SectionTitle>Modifier le Nom de Domaine</SectionTitle>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Modifiez les informations du nom de domaine sélectionné
            </Typography>
          </DialogTitle>

          <Divider sx={{ mb: 2 }} />

          <DialogContent sx={{ pt: 2 }}>
            {/* Numéro Interne */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Numéro Interne</InputLabel>
              <Select
                value={selectedDomaine?.numero_interne || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, numero_interne: e.target.value })}
                label="Numéro Interne"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                {numerosInternes.map((num) => (
                  <MenuItem key={num.id} value={num.numero}>{num.numero}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Société */}
            <FormControl fullWidth error={!!domaineFormErrors.societe_id} sx={{ mb: 2 }}>
              <InputLabel id="domaine-societe-edit-label">Société *</InputLabel>
              <Select
                labelId="domaine-societe-edit-label"
                value={selectedDomaine?.societe_id || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, societe_id: e.target.value })}
                label="Société *"
                sx={{
                  backgroundColor: alpha(theme.palette.background.paper, 0.95),
                  borderRadius: '12px'
                }}
              >
                <MenuItem value=""><em>Choisir une société</em></MenuItem>
                {societes.map((soc) => (
                  <MenuItem key={soc.id} value={soc.id}>{soc.nom}</MenuItem>
                ))}
              </Select>
              {domaineFormErrors.societe_id && (
                <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
                  {domaineFormErrors.societe_id}
                </Typography>
              )}
            </FormControl>

            {/* Nom de Domaine */}
            <TextField
              label="Nom de Domaine"
              fullWidth
              value={selectedDomaine?.nom_domaine || ""}
              onChange={(e) => setSelectedDomaine({ ...selectedDomaine, nom_domaine: e.target.value })}
              error={!!domaineFormErrors.nom_domaine}
              helperText={domaineFormErrors.nom_domaine}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
            />

            {/* Compte Comptable */}
            <TextField
              label="Compte Comptable"
              fullWidth
              value={selectedDomaine?.compte_comptable || ""}
              onChange={(e) => setSelectedDomaine({ ...selectedDomaine, compte_comptable: e.target.value })}
              error={!!domaineFormErrors.compte_comptable}
              helperText={domaineFormErrors.compte_comptable}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
            />

            {/* Propriétaire */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Propriétaire</InputLabel>
              <Select
                value={selectedDomaine?.proprietaire || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, proprietaire: e.target.value })}
                label="Propriétaire"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                {proprietaires.map((p) => (
                  <MenuItem key={p.id} value={p.nom}>{p.nom}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Utilisateur */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Utilisateur</InputLabel>
              <Select
                value={selectedDomaine?.utilisateur || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, utilisateur: e.target.value })}
                label="Utilisateur"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                {utilisateurs.map((u) => (
                  <MenuItem key={u.id} value={u.nom}>{u.nom}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Marque */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Marque</InputLabel>
              <Select
                value={selectedDomaine?.marque || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, marque: e.target.value })}
                label="Marque"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                {marques.map((m) => (
                  <MenuItem key={m.id} value={m.nom}>{m.nom}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Statut */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Statut</InputLabel>
              <Select
                value={selectedDomaine?.statut || "ACTIF"}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, statut: e.target.value })}
                label="Statut"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                <MenuItem value="ACTIF">ACTIF</MenuItem>
                <MenuItem value="NON ACTIF">NON ACTIF</MenuItem>
                <MenuItem value="A FERMER">A FERMER</MenuItem>
              </Select>
            </FormControl>

            {/* Date Renouvellement */}
            <TextField
              label="Date Renouvellement"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={selectedDomaine?.date_renouvellement || ""}
              onChange={(e) => setSelectedDomaine({ ...selectedDomaine, date_renouvellement: e.target.value })}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
            />

            {/* Hébergeur */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Hébergeur</InputLabel>
              <Select
                value={selectedDomaine?.hebergeur || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, hebergeur: e.target.value })}
                label="Hébergeur"
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                {hebergeurs.map((h) => (
                  <MenuItem key={h.id} value={h.nom}>{h.nom}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Renouvellement HT */}
            <TextField
              label="Renouvellement HT"
              type="number"
              fullWidth
              value={selectedDomaine?.renouvellement_ht || ""}
              onChange={(e) => setSelectedDomaine({ ...selectedDomaine, renouvellement_ht: e.target.value })}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
            />

            {/* Renouvellement Automatique */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedDomaine?.automatique || false}
                  onChange={(e) => setSelectedDomaine({ ...selectedDomaine, automatique: e.target.checked })}
                />
              }
              label="Renouvellement Automatique"
              sx={{ mb: 2 }}
            />

            {/* Périodicité */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Périodicité</InputLabel>
              <Select
                value={selectedDomaine?.periodicite || ""}
                onChange={(e) => setSelectedDomaine({ ...selectedDomaine, periodicite: e.target.value })}
                label="Périodicité"
                disabled={!selectedDomaine?.automatique}
                sx={{ backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
              >
                {[...Array(10).keys()].map((i) => (
                  <MenuItem key={i + 1} value={`${i + 1} an(s)`}>{i + 1} an(s)</MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Commentaires */}
            <TextField
              label="Commentaires"
              fullWidth
              multiline
              rows={3}
              value={selectedDomaine?.commentaires || ""}
              onChange={(e) => setSelectedDomaine({ ...selectedDomaine, commentaires: e.target.value })}
              sx={{ mb: 2, backgroundColor: alpha(theme.palette.background.paper, 0.95), borderRadius: '12px' }}
            />
          </DialogContent>

          <Divider sx={{ mt: 2 }} />

          <DialogActions sx={{ px: 3, py: 2.5, gap: 1.5 }}>
            <Button
              onClick={handleCloseEdit}
              sx={{
                color: theme.palette.error.main,
                borderRadius: "10px",
                px: 3,
                py: 1,
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                },
              }}
            >
              Annuler
            </Button>
            <Button
              onClick={handleEditSubmit}
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "10px",
                px: 4,
                py: 1,
                fontWeight: 600,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                "&:hover": {
                  background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                  transform: "translateY(-2px)",
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                transition: "all 0.3s ease",
              }}
            >
              Enregistrer
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* ── Modale résiliation ── */}
      <ResiliationModal
        open={resiliationModal.open}
        onClose={handleResiliationClose}
        item={resiliationModal.item}
        type={resiliationModal.type}
        token={token}
        role={role}
        onSuccess={handleActionSuccess}
      />

      {/* ── Modale renouvellement ── */}
      <RenouvellementModal
        open={renouvellementModal.open}
        onClose={handleRenouvellementClose}
        item={renouvellementModal.item}
        type={renouvellementModal.type}
        token={token}
        role={role}
        onSuccess={handleActionSuccess}
      />
    </Box>
  );
};

export default AdminAlertes;